// import React, { useEffect, useState } from 'react'
// import ReactDatePicker from "react-datepicker";
// import { Button } from "../../common/Button/Button";
// import JpmcMainTable from './JpmcMainTable';
// import AgeWiseJpmcTable from './AgeWiseJpmcTable';
// import SectorWiseJpmcTable from './SectorWiseJpmcTable';
// import FamilyIncomeJpmcTable from './FamilyIncomeJpmcTable';
// import IncomeJpmcTable from './IncomeJpmcTable';
// import api from '../../utils/api';
// import Spinner from '../../common/Spinner/Spinner';
// import DataPieChart from './DataPieChart';
// import CustomHistogramChart from './CustomHistogramChart';
// import HistogramTotalBeneficiaryChart from './HistogramTotalBeneficiaryChart';
// import CompliancePieChart from './CompliancePieChart';
// import MarketLinkagePieChart from './MarketLinkagePieChart';
// import DeliveredResourcePieChart from './DeliveredResourcePieChart';
// import { toast } from 'react-toastify';
// import JpmcExpenseTable from './JpmcExpenseTable';
// import { DOWNLOAD_API_URL } from '../../utils/constants';
// import KnowledgeSessionPieChart from './KnowledgeSessionPieChart';
// import { Info } from 'react-feather';



// const JpmcDashboardContainer = () => {

//     const [fromDate, setfromDate] = useState();
//     const [toDate, settoDate] = useState();
//     const [ageWiseData, setAgeWiseData] = useState([])
//     const [sectorWiseData, setSectorWiseData] = useState([])
//     const [familyIncData, setFamilyIncData] = useState([])
//     const [businessIncData, setBusinessIncData] = useState([])
//     const [combineData, setCombineData] = useState([])
//     const [clearClicked, setClearClicked] = useState(false);
//     const [isLoading, setIsLoading] = useState(false)
//     const [countData, setCountData] = useState("")
//     const [mobilizationCountData, setMobilizationCountData] = useState("")
//     const [totalBeneChartData, setTotalBeneChartData] = useState([])
//     const [groupKnowledgeData, setGroupKnowliedgeData] = useState()
//     const [expertData, setExpertData] = useState()
//     const [marketConnectData, setMarketConnectData] = useState()
//     const [complianceData, setComplianceData] = useState()
//     const [blrpData, setBlrpData] = useState()
//     const [loadMore, setLoadMore] = useState(false)
//     const [filteredCompliance, setFilteredCompliance] = useState([])
//     const [filteredMarketLinkage, setFilteredMarketLinkage] = useState([])
//     const [summaryData, setSummaryData] = useState([])
//     const [jpmcExpsData, setJpmcExpsData] = useState([])

//     const [complianceRequested, setComplianceRequested] = useState()
//     const [complianceProgress, setComplianceProgress] = useState()
//     const [complianceDelivered, setComplianceDelivered] = useState()
//     const [complianceCancellled, setComplianceCancelled] = useState()

//     const [groupKnowledgeSessionRequested, setGroupKnowledgeSessionRequested] = useState()
//     const [groupKnowledgeSessionProgress, setGroupKnowledgeSessionProgress] = useState()
//     const [groupKnowledgeSessionDelivered, setGroupKnowledgeSessionDelivered] = useState()

//     const [expertConsultationRequested, setExpertConsultationRequested] = useState()
//     const [expertConsultationProgress, setExpertConsultationProgress] = useState()
//     const [expertConsultationDelivered, setExpertConsultationDelivered] = useState()
//     const [experConsultationCancelled, setExpertConsultationCancelled] = useState()

//     const [marketConnectRequested, setMarketConnectRequested] = useState()
//     const [marketConnectProgress, setMarketConnectProgress] = useState()
//     const [marketConnectDelivered, setMarketConnectDelivered] = useState()

//     const [blrpRequested, setBlrpRequested] = useState()   
//     const [blrpProgress, setBlrpProgress] = useState()
//     const [blrpDelivered, setBlrpDelivered] = useState()
//     const [blrpCancelled, setBlrpCancelled] = useState()

//     useEffect(() => {
//         const mobileWidthBreakpoint = 768;

//         const displayToastForMobileResolution = () => {
//             if (window.innerWidth < mobileWidthBreakpoint) {
//                 toast("This dashboard is best viewable in a desktop browser.", {
//                     autoClose: 5000,
//                     type: toast.TYPE.ERROR,
//                 });
//             }
//         };

//         displayToastForMobileResolution();

//         window.addEventListener('resize', displayToastForMobileResolution);

//         return () => window.removeEventListener('resize', displayToastForMobileResolution);
//     }, []);

//     const ondatechange = (key, date) => {
//         if (key === "fromDate") {
//             setfromDate(date)

//         } else if (key === "toDate") {
//             settoDate(date)

//         }
//     };

//     const dateAdjusted = (date) => {
//         let toDateAdjusted;
//         if (date) {
//             toDateAdjusted = new Date(date);

//             toDateAdjusted = new Date(
//                 toDateAdjusted.setTime(
//                     toDateAdjusted.getTime() + (29.5 * 60 * 60 * 1000 - 1000)
//                 )
//             );
//         }
//         return toDateAdjusted;
//     }

//     const dateAdjusted1 = (date) => {
//         let toDateAdjusted;
//         if (date) {
//             toDateAdjusted = new Date(date);

//             toDateAdjusted = new Date(
//                 toDateAdjusted.setTime(
//                     toDateAdjusted.getTime() + (5.5 * 60 * 60 * 1000)
//                 )
//             );
//         }
//         return toDateAdjusted;
//     }

//     const filterAndCombineData = (data, keyToCompare) => {
//         const combinedData = {};

//         data.forEach(entry => {
//             const key = `${entry[keyToCompare]}_${entry.sResourceDisplayName}`;

//             if (combinedData[key]) {
//                 combinedData[key].sMobile_count += entry.sMobile_count;
//             } else {
//                 combinedData[key] = { ...entry };
//             }
//         });

//         const combinedDataArray = Object.values(combinedData);

//         return combinedDataArray;
//     };

//     useEffect(() => {
//         setSummaryData([
//                 ["Expert Consultation", expertConsultationDelivered],
//                 ["Market Connect", marketConnectDelivered],
//                 ["Group Knowledge Session", groupKnowledgeSessionDelivered],
//                 ["BLRP", blrpDelivered],
//                 ["Compliance", complianceDelivered]
//             ])
//     }, [groupKnowledgeSessionDelivered, complianceDelivered,expertConsultationDelivered,marketConnectDelivered,blrpDelivered])

//     const getTableData = () => {
//         let filterParameters = {}

//         if (fromDate) {
//             filterParameters.fromDate = dateAdjusted1(fromDate)
//         }

//         if (toDate) {
//             filterParameters.toDate = dateAdjusted(toDate)
//         }

//         console.log("Filter", filterParameters)
//         setIsLoading(true)

//         let payload = {
//             api_key : "r54B?rHXUE7v%$9t",
//             // api_key : "82mqEyJnct4kzC8y",

//         }

//         const { tempMobilizationCount } = api.mobilizationCountApi(payload)
//         .then(({data}) => {
//             setMobilizationCountData(data.data.total_count)
//         })

//         const { tempCountData } = api.jpmcCountData(filterParameters)
//             .then(({ data }) => {
//                 console.log("COUNT", data.count)
//                 setCountData(data.count)
//             })

//         const { tempTotalBeneficiaryData } = api.totalBeneficiaryChartData(filterParameters)
//             .then(({ data }) => {
//                 console.log("Chart Data", data)
//                 setTotalBeneChartData(data)
//             })

//         const { tempJpmcExpenseData } = api.jpmcExpenseTableData(filterParameters)
//             .then(({ data }) => {
//                 console.log("Expense Data", data)
//                 setJpmcExpsData(data.data)
//             })

//         const {tempComplianceReport} = api.getComplianceReportAPI(filterParameters)
//         .then(({data}) => {
//             console.log("Data Report Compliance", data)
//         })

//         const {tempExpertConsultaionReport} = api.getExpertConsultationReport(filterParameters)
//         .then(({data}) => {
//             console.log("Data Report Expert", data)
//         })

//         const {tempMobilizationReport} = api.getMobilizationReport(filterParameters)
//         .then(({data}) => {
//             console.log("Data Report Mobilization", data)
//         })

//         const {tempBlrpReport} = api.getBlrpReport(filterParameters)
//         .then(({data}) => {
//             console.log("Data Report blrp", data)
//         })

//         const {tempGroupKnowledgeReport} = api.getGroupKnowledgeReport(filterParameters)
//         .then(({data}) => {
//             console.log("Data Report Groupknowledge", data)
//         })

//         const {tempMarketLinkage} = api.getMarketLinkageReport(filterParameters)
//         .then(({data}) => {
//             console.log("Data Report MarketLinkage", data)
//         })

//         const {tempJpmcAllData} = api.getJpmcAllData(filterParameters)
//         .then(({data}) => {
//             console.log("Data Report All", data);
//         })

//         let complianceCount = 0;
//         let complianceCountDelivered = 0;
//         let complianceCountRequested = 0;
//         let complianceCountProgress = 0;
//         let complianceCountCancelled = 0;

//         let groupKnowledgeSessionCount = 0;
//         let groupKnowledgeSessionCountDelivered = 0;
//         let groupKnowledgeSessionCountRequested = 0;
//         let groupKnowledgeSessionCountProgress = 0;
//         let groupKnowledgeSessionCountCancelled = 0;

//         let expertConsultationCount = 0;
//         let expertConsultationCountDelivered = 0;
//         let expertConsultationCountRequested = 0;
//         let expertConsultationCountProgress = 0;
//         let expertConsultationCountCancelled = 0;

//         let marketConnectCount = 0;
//         let marketConnectCountDelivered = 0;
//         let marketConnectCountRequested = 0;
//         let marketConnectCountProgress = 0;
//         let marketConnectCountCancelled = 0;

//         let blrpCount = 0;
//         let blrpCountDelivered = 0;
//         let blrpCountRequested = 0;
//         let blrpCountProgress = 0;
//         let blrpCountCancelled = 0;

//         const { tempCombineData } = api.mainTableData(filterParameters)
//             .then(({ data }) => {
//                 setCombineData(data)

//                 const ageData = filterAndCombineData(data, 'age')
//                 setAgeWiseData(ageData)

//                 const sectorData = filterAndCombineData(data, 'sBusinessSector')
//                 setSectorWiseData(sectorData)

//                 const BusinessIncData = filterAndCombineData(data, 'sBusinessTurnover')
//                 setBusinessIncData(BusinessIncData)

//                 const FamIncData = filterAndCombineData(data, 'sFamilyIncome')
//                 setFamilyIncData(FamIncData)

//                 let groupKnowledgeSessionCount = 0;
//                 let expertConsultationCount = 0;
//                 let marketConnectCount = 0;
//                 let complianceCount = 0;
//                 let blrpCount = 0;

//                 let groupKnowledgeSessionCountDelivered = 0;
//                 let expertConsultationCountDelivered = 0;
//                 let marketConnectCountDelivered = 0;
//                 let complianceCountDelivered = 0;
//                 let blrpCountDelivered = 0;

//                 let groupKnowledgeSessionCountRequested = 0;
//                 let expertConsultationCountRequested = 0;
//                 let marketConnectCountRequested = 0;
//                 let complianceCountRequested = 0;
//                 let blrpCountRequested = 0;

//                 let groupKnowledgeSessionCountProgress = 0;
//                 let expertConsultationCountProgress = 0;
//                 let marketConnectCountProgress = 0;
//                 let complianceCountProgress = 0;
//                 let blrpCountProgress = 0;

//                 let groupKnowledgeSessionCountCancelled = 0;
//                 let expertConsultationCountCancelled = 0;
//                 let marketConnectCountCancelled = 0;
//                 let complianceCountCancelled = 0;
//                 let blrpCountCancelled = 0;

//                 const uniqueCompliance = new Set();

//                 const filterComplianceCountData = data.filter((item) => {
//                     if ((item.sResourceDisplayName === 'Shop Act Intimation' || item.sResourceDisplayName === 'Udyam Registration' || item.sResourceDisplayName === 'FSSAI License' || item.sResourceDisplayName === 'Copyright Registration'
//                     || item.sResourceDisplayName === 'Trademark Registration' || item.sResourceDisplayName === 'FSSAI Registration' || item.sResourceDisplayName === 'GST Registration') &&
//                         !uniqueCompliance.has(item.sMobile)) {
                        
//                         uniqueCompliance.add(item.sMobile);
//                         return true;
//                     }
//                     return false;
//                 });

//                 const uniqueMarketLinkage = new Set()

//                 const filterMarketLinkageCountData = data.filter((item) => {
//                     if ((item.sResourceID === 'MKTLINKAGEBULKBUYER' || item.sResourceID === 'MKTLINKAGEEXHIBITION' || item.sResourceID === 'MKTLINKAGECORPLINKAGE' || item.sResourceID === 'MKTLINKAGEEXPORT' || item.sResourceID === 'MKTLINKAGEECOM' || item.sResourceID === 'MKTLINKAGESHOPINSHOP') &&
//                         !uniqueMarketLinkage.has(item.sMobile)) {
                        
//                             uniqueMarketLinkage.add(item.sMobile);
//                         return true;
//                     }
//                     return false;
//                 });

//                 const uniqueExpert = new Set()

//                 const filterExpertCountData = data.filter((item) => {
//                     if ((item.sResourceID === 'LTEXPCOACH' || item.sResourceID === 'EXPRTCONSULT') &&
//                         !uniqueExpert.has(item.sMobile)) {
                        
//                             uniqueExpert.add(item.sMobile);
//                         return true;
//                     }
//                     return false;
//                 });

//                 const uniqueGroupSession = new Set()

//                 const filterGroupSessionCountData = data.filter((item) => {
//                     if ((item.sResourceID === 'GRPEXPRTCONSULT') &&
//                         !uniqueGroupSession.has(item.sMobile)) {
                        
//                             uniqueGroupSession.add(item.sMobile);
//                         return true;
//                     }
//                     return false;
//                 });

//                 const uniqueBLRP = new Set()

//                 const filterBLRPCountData = data.filter((item) => {
//                     if ((item.sResourceID === 'FUNDRDYPRPSL') &&
//                         !uniqueBLRP.has(item.sMobile)) {
                        
//                             uniqueBLRP.add(item.sMobile);
//                         return true;
//                     }
//                     return false;
//                 });

//                 console.log("Heyyyyy",filterBLRPCountData)

//                 const filteredData = data.filter((item) => {
//                     if (item.sResourceDisplayName === 'Shop Act Intimation' || item.sResourceDisplayName === 'Udyam Registration' || item.sResourceDisplayName === 'FSSAI License' || item.sResourceDisplayName === 'Copyright Registration'
//                         || item.sResourceDisplayName === 'Trademark Registration' || item.sResourceDisplayName === 'FSSAI Registration' || item.sResourceDisplayName === 'GST Registration') {
//                         return item;
//                     }
//                 })

//                 const filteredMarketLinkageData = data.filter((item) => {
//                     if (item.sResourceDisplayName === 'Bulk Buyer' || item.sResourceDisplayName === 'Exhibition' || item.sResourceDisplayName === 'Corporate Linkage' || item.sResourceDisplayName === 'Export' || item.sResourceDisplayName === 'Ecommerce' || item.sResourceDisplayName === 'Shop in Shop') {
//                         return item
//                     }
//                 })

//                 setFilteredCompliance(filteredData)
//                 setFilteredMarketLinkage(filteredMarketLinkageData)

//                 // data.forEach(item => {
//                 //     if (item.sResourceDisplayName === 'Xpert Coaching' || item.sResourceDisplayName === 'Xpert Clinic') {
//                 //         expertConsultationCount++;
//                 //     } else if (item.sResourceDisplayName === 'Bulk Buyer' || item.sResourceDisplayName === 'Exhibition' || item.sResourceDisplayName === 'Corporate Linkage' || item.sResourceDisplayName === 'Export' || item.sResourceDisplayName === 'Ecommerce' || item.sResourceDisplayName === 'Shop in Shop') {
//                 //         marketConnectCount++;
//                 //     } else if (item.sResourceDisplayName === 'Group Expert Consult') {
//                 //         groupKnowledgeSessionCount++;
//                 //     } else if (item.sResourceDisplayName === 'Business Loan Readiness Program (BLRP)') {
//                 //         blrpCount++;
//                 //     } else if (item.sResourceDisplayName === 'Shop Act Intimation' || item.sResourceDisplayName === 'GST Returns Filing' || item.sResourceDisplayName === 'Udyam Registration'
//                 //     || item.sResourceDisplayName === 'FSSAI License' || item.sResourceDisplayName === 'Rent Agreement Registration' || item.sResourceDisplayName === 'Copyright Registration'
//                 //     || item.sResourceDisplayName === 'Trademark Registration' || item.sResourceDisplayName === 'FSSAI Registration' || item.sResourceDisplayName === 'Partnership Deed Drafting'
//                 //     || item.sResourceDisplayName === 'One Person Company (OPC) Formation'|| item.sResourceDisplayName === 'Limited Liability Partnership Firm (LLP)'|| item.sResourceDisplayName === 'Private Limited Company Formation'
//                 //     ||item.sResourceDisplayName === 'GST Registration'){
//                 //         complianceCount++;
//                 //     }
//                 // });

//                 // data.forEach(item => {
//                 //     if (item.refCurrentStateSPM === 'Delivered') { 
//                 //         if (item.sResourceID === 'LTEXPCOACH' || item.sResourceID === 'EXPRTCONSULT') {
//                 //             expertConsultationCount++;
//                 //         } else if (item.sResourceID === 'MKTLINKAGEBULKBUYER' || item.sResourceID === 'MKTLINKAGEEXHIBITION' || item.sResourceID === 'MKTLINKAGECORPLINKAGE' || item.sResourceID === 'MKTLINKAGEEXPORT' || item.sResourceID === 'MKTLINKAGEECOM' || item.sResourceID === 'MKTLINKAGESHOPINSHOP') {
//                 //             marketConnectCount++;
//                 //         } else if (item.sResourceID === 'GRPEXPRTCONSULT') {
//                 //             groupKnowledgeSessionCount++;
//                 //         } else if (item.sResourceDisplayName === 'Business Loan Readiness Program session(BLRP)') {
//                 //             blrpCount++;
//                 //         } else if (item.sResourceID === 'SHOPACT' || item.sResourceID === 'GSTRETURNFILING' || item.sResourceID === 'UDYAMREG'
//                 //                 || item.sResourceID === 'FSSAILICENSE' || item.sResourceID === 'LVLICENSEAGRREG' || item.sResourceID === 'COPYRIGHT'
//                 //                 || item.sResourceID === 'FSSAI' || item.sResourceID === 'TRADMRK' || item.sResourceID === 'PARTSHIPDEED'
//                 //                 || item.sResourceID === 'OPCFORM'|| item.sResourceID === 'LLPFORM'|| item.sResourceID === 'PVTLTDCOMP'
//                 //                 || item.sResourceID === 'GSTREG') {
//                 //             complianceCount++;
//                 //         }
//                 //     }
//                 // });

//                 filterComplianceCountData.forEach(item => {
//                     complianceCount += item.sMobile_count || 0;

//                         if(item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled"){
//                             complianceCountCancelled += item.sMobile_count || 0;
//                         }

//                         if(item.refCurrentStateSPM === ""){
//                             if(item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
//                             item.refSRStateLPM === "Prepared" ||item.refSRStateLPM === "Partial/ Full Payment Pending" ||
//                             item.refSRStateLPM === "Quotation Sent" ){
//                                 complianceCountRequested += item.sMobile_count || 0;
//                             }

//                             if(item.refSRStateLPM === "Payment Received"){
//                                 complianceCountProgress += item.sMobile_count || 0;
//                             }
//                         }

//                         if(item.refCurrentStateSPM !== ""){
//                             if(item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled"){
//                                 complianceCountProgress += item.sMobile_count || 0;
//                             }

//                             if(item.refCurrentStateSPM === "Delivered"){
//                                 complianceCountDelivered += item.sMobile_count || 0;
//                             }
//                         }
//                 })

//                 filterExpertCountData.forEach(item => {
//                     expertConsultationCount += item.sMobile_count || 0;

//                         if(item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled"){
//                             expertConsultationCountCancelled += item.sMobile_count || 0;
//                         }

//                         if(item.refCurrentStateSPM === ""){
//                             if(item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
//                             item.refSRStateLPM === "Prepared" ||item.refSRStateLPM === "Partial/ Full Payment Pending" ||
//                             item.refSRStateLPM === "Quotation Sent" ){
//                                 expertConsultationCountRequested += item.sMobile_count || 0;
//                             }

//                             if(item.refSRStateLPM === "Payment Received"){
//                                 expertConsultationCountProgress += item.sMobile_count || 0;
//                             }
//                         }
                        
//                         if(item.refCurrentStateSPM !== ""){
//                             if(item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled"){
//                                 expertConsultationCountProgress += item.sMobile_count || 0;
//                             }

//                             if(item.refCurrentStateSPM === "Delivered"){
//                                 expertConsultationCountDelivered += item.sMobile_count || 0;
//                             }
//                         }
//                 })

//                 filterMarketLinkageCountData.forEach(item => {
//                     marketConnectCount += item.sMobile_count || 0;
//                         if(item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled"){
//                             marketConnectCountRequested += item.sMobile_count || 0;
//                         }

//                         if(item.refCurrentStateSPM === "Delivered"){
//                             marketConnectCountDelivered += item.sMobile_count || 0;
//                         }
//                 })

//                 filterGroupSessionCountData.forEach(item => {
//                     groupKnowledgeSessionCount += item.sMobile_count || 0;
//                         if(item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled"){
//                             groupKnowledgeSessionCountRequested += item.sMobile_count || 0;
//                         }

//                         if(item.refCurrentStateSPM === "Delivered"){
//                             groupKnowledgeSessionCountDelivered += item.sMobile_count || 0;
//                         }
//                 })

//                 filterBLRPCountData.forEach(item => {
//                     blrpCount += item.sMobile_count || 0;

//                         if(item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled"){
//                             blrpCountCancelled += item.sMobile_count || 0;
//                         }

//                         if(item.refCurrentStateSPM === ""){
//                             if(item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
//                             item.refSRStateLPM === "Prepared" ||item.refSRStateLPM === "Partial/ Full Payment Pending" ||
//                             item.refSRStateLPM === "Quotation Sent" ){
//                                 blrpCountRequested += item.sMobile_count || 0;
//                             }

//                             if(item.refSRStateLPM === "Payment Received"){
//                                 blrpCountProgress += item.sMobile_count || 0;
//                             }
//                         }
                        
//                         if(item.refCurrentStateSPM !== ""){
//                             if(item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled"){
//                                 blrpCountProgress += item.sMobile_count || 0;
//                             }

//                             if(item.refCurrentStateSPM === "Delivered"){
//                                 blrpCountDelivered += item.sMobile_count || 0;
//                             }
//                         }
//                 })

//                 data.forEach(item => {
//                     // if (item.refCurrentStateSPM === 'Delivered') { 
//                     // if (item.sResourceID === 'LTEXPCOACH' || item.sResourceID === 'EXPRTCONSULT') {
//                     //     expertConsultationCount += item.sMobile_count || 0;
//                     //     // if(item.refSRStateLPM === "Requested"){
//                     //     //     expertConsultationCountRequested += item.sMobile_count || 0;
//                     //     // } else if(item.refSRStateLPM === "Payment Received"){
//                     //     //     if(item.refCurrentStateSPM !== "Delivered"){
//                     //     //         expertConsultationCountProgress += item.sMobile_count || 0;
//                     //     //     }
//                     //     // }

//                     //     if(item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled"){
//                     //         expertConsultationCountCancelled += item.sMobile_count || 0;
//                     //     }

//                     //     if(item.refCurrentStateSPM === ""){
//                     //         if(item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
//                     //         item.refSRStateLPM === "Prepared" ||item.refSRStateLPM === "Partial/ Full Payment Pending" ||
//                     //         item.refSRStateLPM === "Quotation Sent" ){
//                     //             expertConsultationCountRequested += item.sMobile_count || 0;
//                     //         }

//                     //         if(item.refSRStateLPM === "Payment Received"){
//                     //             expertConsultationCountProgress += item.sMobile_count || 0;
//                     //         }
//                     //     }
                        
//                     //     if(item.refCurrentStateSPM !== ""){
//                     //         if(item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled"){
//                     //             expertConsultationCountProgress += item.sMobile_count || 0;
//                     //         }
//                     //     }

//                     // }
//                     //   if (item.sResourceID === 'MKTLINKAGEBULKBUYER' || item.sResourceID === 'MKTLINKAGEEXHIBITION' || item.sResourceID === 'MKTLINKAGECORPLINKAGE' || item.sResourceID === 'MKTLINKAGEEXPORT' || item.sResourceID === 'MKTLINKAGEECOM' || item.sResourceID === 'MKTLINKAGESHOPINSHOP') {
//                     //     marketConnectCount += item.sMobile_count || 0;
//                     //     if(item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled"){
//                     //         marketConnectCountRequested += item.sMobile_count || 0;
//                     //     }
//                     // } 
//                     //  if (item.sResourceID === 'GRPEXPRTCONSULT') {
//                     //     groupKnowledgeSessionCount += item.sMobile_count || 0;
//                     //     if(item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled"){
//                     //         groupKnowledgeSessionCountRequested += item.sMobile_count || 0;
//                     //     }
//                     // } 
//                     //  if (item.sResourceID === 'FUNDRDYPRPSL') {
//                     //     blrpCount += item.sMobile_count || 0;
//                     //     // if(item.refSRStateLPM === "Requested"){
//                     //     //     blrpCountRequested += item.sMobile_count || 0;
//                     //     // } else if(item.refSRStateLPM === "Payment Received") {
//                     //     //     if(item.refCurrentStateSPM !== "Delivered"){
//                     //     //         blrpCountProgress += item.sMobile_count || 0;
//                     //     //     }
//                     //     // }

//                     //     if(item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled"){
//                     //         blrpCountCancelled += item.sMobile_count || 0;
//                     //     }

//                     //     if(item.refCurrentStateSPM === ""){
//                     //         if(item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
//                     //         item.refSRStateLPM === "Prepared" ||item.refSRStateLPM === "Partial/ Full Payment Pending" ||
//                     //         item.refSRStateLPM === "Quotation Sent" ){
//                     //             blrpCountRequested += item.sMobile_count || 0;
//                     //         }

//                     //         if(item.refSRStateLPM === "Payment Received"){
//                     //             blrpCountProgress += item.sMobile_count || 0;
//                     //         }
//                     //     }
                        
//                     //     if(item.refCurrentStateSPM !== ""){
//                     //         if(item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled"){
//                     //             blrpCountProgress += item.sMobile_count || 0;
//                     //         }
//                     //     }

//                     // }
//                     //  else if (item.sResourceID === 'SHOPACT' || item.sResourceID === 'GSTRETURNFILING' || item.sResourceID === 'UDYAMREG'
//                     //     || item.sResourceID === 'FSSAILICENSE' || item.sResourceID === 'LVLICENSEAGRREG' || item.sResourceID === 'COPYRIGHT'
//                     //     || item.sResourceID === 'FSSAI' || item.sResourceID === 'TRADMRK' || item.sResourceID === 'PARTSHIPDEED'
//                     //     || item.sResourceID === 'OPCFORM' || item.sResourceID === 'LLPFORM' || item.sResourceID === 'PVTLTDCOMP'
//                     //     || item.sResourceID === 'GSTREG') {
//                     //     complianceCount += item.sMobile_count || 0;
//                     // }
//                     //  else if (item.sResourceID === 'SHOPACT' || item.sResourceID === 'UDYAMREG' || item.sResourceID === 'FSSAILICENSE' || item.sResourceID === 'COPYRIGHT'
//                     //  || item.sResourceID === 'FSSAI' || item.sResourceID === 'TRADMRK' || item.sResourceID === 'GSTREG') {
//                     //     complianceCount += item.sMobile_count || 0;

//                     //     if(item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled"){
//                     //         complianceCountCancelled += item.sMobile_count || 0;
//                     //     }

//                     //     if(item.refCurrentStateSPM === ""){
//                     //         if(item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
//                     //         item.refSRStateLPM === "Prepared" ||item.refSRStateLPM === "Partial/ Full Payment Pending" ||
//                     //         item.refSRStateLPM === "Quotation Sent" ){
//                     //             complianceCountRequested += item.sMobile_count || 0;
//                     //         }

//                     //         if(item.refSRStateLPM === "Payment Received"){
//                     //             complianceCountProgress += item.sMobile_count || 0;
//                     //         }
//                     //     }

//                     //     if(item.refCurrentStateSPM !== ""){
//                     //         if(item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled"){
//                     //             complianceCountProgress += item.sMobile_count || 0;
//                     //         }
//                     //     }



                        

//                     //     // if(item.refSRStateLPM === "Requested"){
//                     //     //     complianceCountRequested += item.sMobile_count || 0;
//                     //     // } else if(item.refSRStateLPM === "Payment Received") {
//                     //     //     if(item.refCurrentStateSPM !== "Delivered"){
//                     //     //         complianceCountProgress += item.sMobile_count || 0;
//                     //     //     }
//                     //     // }
//                     // }
//                     // }
//                 });

//                 data.forEach(item => {
//                     if (item.refCurrentStateSPM === 'Delivered') { 
//                     if (item.sResourceID === 'LTEXPCOACH' || item.sResourceID === 'EXPRTCONSULT') {
//                         // expertConsultationCountDelivered += item.sMobile_count || 0;
//                     } 
//                     else if (item.sResourceID === 'MKTLINKAGEBULKBUYER' || item.sResourceID === 'MKTLINKAGEEXHIBITION' || item.sResourceID === 'MKTLINKAGECORPLINKAGE' || item.sResourceID === 'MKTLINKAGEEXPORT' || item.sResourceID === 'MKTLINKAGEECOM' || item.sResourceID === 'MKTLINKAGESHOPINSHOP') {
//                         // marketConnectCountDelivered += item.sMobile_count || 0;
//                     } 
//                     else if (item.sResourceID === 'GRPEXPRTCONSULT') {
//                         // groupKnowledgeSessionCountDelivered += item.sMobile_count || 0;
//                     } else if (item.sResourceID === 'FUNDRDYPRPSL') {
//                         // blrpCountDelivered += item.sMobile_count || 0;
//                     } 
//                     // else if (item.sResourceID === 'SHOPACT' || item.sResourceID === 'UDYAMREG' || item.sResourceID === 'FSSAILICENSE' || item.sResourceID === 'COPYRIGHT'
//                     // || item.sResourceID === 'FSSAI' || item.sResourceID === 'TRADMRK' || item.sResourceID === 'GSTREG') {
//                     //     complianceCountDelivered += item.sMobile_count || 0;
//                     // }
//                     }
//                 });


//                 const summaryData = [
//                     ["Expert Consultation", expertConsultationCount],
//                     ["Market Connect", marketConnectCount],
//                     ["Group Knowledge Session", groupKnowledgeSessionCount],
//                     ["BLRP", blrpCount],
//                     ["Compliance", complianceCount]
//                 ];

//                 const summaryDataForDelivered = [
//                     ["Expert Consultation", expertConsultationCountDelivered],
//                     ["Market Connect", marketConnectCountDelivered],
//                     ["Group Knowledge Session", groupKnowledgeSessionCountDelivered],
//                     ["BLRP", blrpCountDelivered],
//                     ["Compliance", complianceCountDelivered]
//                 ];

//                 console.log("SummaryData", summaryData)
//                 setSummaryData(summaryDataForDelivered);

//                 setExpertData(expertConsultationCount);
//                 setMarketConnectData(marketConnectCount);
//                 setComplianceData(complianceCount);
//                 setGroupKnowliedgeData(groupKnowledgeSessionCount)
//                 setBlrpData(blrpCount)

//                 setComplianceDelivered(complianceCountDelivered)
//                 setComplianceRequested(complianceCountRequested)
//                 setComplianceProgress(complianceCountProgress)
//                 setComplianceCancelled(complianceCountCancelled)

//                 setGroupKnowledgeSessionRequested(groupKnowledgeSessionCountRequested)
//                 setGroupKnowledgeSessionDelivered(groupKnowledgeSessionCountDelivered)

//                 setExpertConsultationRequested(expertConsultationCountRequested)
//                 setExpertConsultationProgress(expertConsultationCountProgress)
//                 setExpertConsultationDelivered(expertConsultationCountDelivered)
//                 setExpertConsultationCancelled(expertConsultationCountCancelled)

//                 setMarketConnectRequested(marketConnectCountRequested)
//                 setMarketConnectDelivered(marketConnectCountDelivered)

//                 setBlrpRequested(blrpCountRequested)
//                 setBlrpProgress(blrpCountProgress)
//                 setBlrpDelivered(blrpCountDelivered)
//                 setBlrpCancelled(blrpCountCancelled)

//                 setIsLoading(false)
//             })


//     }


//     useEffect(() => {
//         getTableData()
//     }, [])

//     const handleSearch = () => {
//         setAgeWiseData([])
//         setSectorWiseData([])
//         setBusinessIncData([])
//         setFamilyIncData([])
//         setCombineData([])
//         setTotalBeneChartData([])
//         getTableData()
//         setJpmcExpsData([])
//     }

//     const handleClear = () => {
//         setfromDate()
//         settoDate()
//         setAgeWiseData([])
//         setSectorWiseData([])
//         setBusinessIncData([])
//         setFamilyIncData([])
//         setCombineData([])
//         setTotalBeneChartData([])
//         setJpmcExpsData([])
//         setClearClicked(true);
//     }


//     useEffect(() => {
//         if (clearClicked) {
//             getTableData();
//             setClearClicked(false);
//         }
//     }, [clearClicked]);

//     function getCurrentDate() {
//         const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//         const today = new Date();
//         const day = String(today.getDate()).padStart(2, '0');
//         const month = months[today.getMonth()];
//         const year = today.getFullYear();
//         return `${day}${month}${year}`;
//     }

//     const currentDate = getCurrentDate();
//     // const title = `Interested = ${groupKnowledgeSessionRequested}&#10;Attended = ${groupKnowledgeSessionDelivered}`;
//     const title = "Interested:" + groupKnowledgeSessionRequested + "\n" + "Attended:" + groupKnowledgeSessionDelivered 

    
//     return (
//         <div className={`${isLoading && "set-opacity"}`}>
//             {isLoading && <Spinner className="center-screen" />}
//             <div className='row mt-2 ml-1'>
//                 <div className="esp-dashboard-card1 conv-text-center" style={{ height: '38px', marginRight: "20px" }}>
//                     <label className="esp-box-header-title">Mobilization: <span style={{ color: "#78417C" }}>{mobilizationCountData || 0}</span></label>
//                     {/* <h5 className="esp-count-text">{0}</h5> */}
//                     <div style={{ clear: "both" }}></div>

//                 </div>
//                 {/* <div className="col-12"> */}
//                 {/* <div className='col-2'> */}
//                 <a className="con-cursor-pointer"
//                                 href={`${DOWNLOAD_API_URL}/static_live/Reports/JPMCDashboardData ${getCurrentDate()}.xlsx`} download={`JPMCDashboardData ${getCurrentDate()}.xlsx`}>

//                                 <button
//                             className="lpm-con-btn-filled conv-pr35 conv-pl35">
//                             Download CSV
//                         </button>
//                                 {/* <Button className="lpm-con-btn-filled conv-pr35 conv-pl35">Download CSV</Button> */}

//                             </a>    

//                             {/* <div className='esp-count-text' style={{
//                     border: '1px solid gray',
//                     borderRadius: '2px',
//                     height: 'fit-content',
//                     padding: '5px 28px',
//                     marginLeft: '25px',
//                     marginRight: '10px',
//                     backgroundColor: '#eee'
//                 }}>
//                     Mobilization: <br/>1000
//                 </div> */}


//                 {/* </div> */}

//                 <div className="col-6 ml-1">
//                     <div className="row">
//                         <div className="col-4 spled-container conv-zindex">
//                             <div className="width-100">
//                                 <ReactDatePicker
//                                     dateFormat="dd/MM/yyyy"
//                                     selected={fromDate}
//                                     onChange={(date) => ondatechange("fromDate", date)}
//                                     placeholderText="From Date"
//                                     minDate={new Date("01-01-2024")}
//                                     maxDate={new Date()}
//                                 />
//                             </div>
//                         </div>

//                         <div className="col-4 spled-container conv-zindex">
//                             <div className="width-100">
//                                 <ReactDatePicker
//                                     dateFormat="dd/MM/yyyy"
//                                     selected={toDate}
//                                     onChange={(date) => ondatechange("toDate", date)}
//                                     placeholderText="To Date"
//                                     minDate={new Date("01-01-2024")}
//                                     maxDate={new Date()}
//                                 />
//                             </div>
//                         </div>

//                         <div className="col-4">
//                             <Button className="esp-inline-button mr-2" style={{
//                                 width: "80px",height: '38px'
//                             }} onClick={handleSearch} >Search</Button>
//                             <Button className="esp-inline-button" style={{
//                                 width: '80px',height: '38px'
//                             }} onClick={handleClear} >Clear</Button>
//                         </div>

//                     </div>
//                 </div>
                
//                 {/* </div> */}



//             </div>

//             <div className="row mb-4">

//                 <div className="col-4">
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff",
//                         height: '220px'
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                          <label className="esp-box-header-title mt-2">Eligible</label> 
//                         {/* <div className='row esp-box-header-title mt-4'>
//                             <div className="col-4"></div>
//                             <div className="col-4">Mobilization</div>
//                             <div className="col-4">Eligible</div>
//                         </div>
//                         <div className='row esp-count-text mt-2'>
//                             <div className="col-4">Target <br/> <span style={{ color: "#78417C" }}>2000</span></div>
//                             <div className="col-4">As on date <br/> <span style={{ color: "#78417C" }}>{mobilizationCountData || 0}</span></div>
//                             <div className="col-4">As on date <br/>
//                             <span style={{ color: "#78417C" }}>
//                                     {countData > 0 ? (
//                                         <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/Eligible ${getCurrentDate()}.xlsx`} download={`Mobilization ${getCurrentDate()}.xlsx`}>
//                                             {countData}
//                                         </a>
//                                     ) : (
//                                         <span>{countData}</span>
//                                     )}
//                             </span>
//                             </div>/
//                         </div> */}
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
//                             <h5 className="esp-count-text">Target <br/> <span style={{ color: "#78417C" }}>2000</span></h5>
//                             <h5 className="esp-count-text">As on Date <br/> <span style={{ color: "#78417C" }}>
//                                 {countData > 0 ? (
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/Eligible ${getCurrentDate()}.xlsx`} download={`Mobilization ${getCurrentDate()}.xlsx`}>
//                                         {countData}
//                                     </a>
//                                 ) : (
//                                     <span>{countData}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         <div style={{ clear: "both" }}></div>
//                         <div style={{justifyContent: 'space-around', padding: "35px" }}></div>
//                         <div className='count-text'>
//                         <span style={{color: 'lightslategray'}}>
//                         *The eligible entrepreneurs were identified for further interventions                        </span>
//                     </div>
//                     </div>
//                 </div>

//                 <div className="col-4">
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff"
//                         height: "220px",
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                         <label className="esp-box-header-title mt-2">Group Knowledge Session</label>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
//                             <h5 className="esp-count-text">Target <br/> <span style={{ color: "#78417C" }}>1500</span></h5>
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{groupKnowledgeData || 0}</span></h5> */}
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>
//                                 <a className="con-cursor-pointer" style={{ color: "#78417C" }}
//                                     href={`${DOWNLOAD_API_URL}/static_live/Reports/JPMCDashboardData.xlsx`} download="JPMCDashboardData.xlsx">
//                                     {groupKnowledgeData || 0}
//                                 </a>
//                             </span>
//                             </h5> */}
//                             <h5 className="esp-count-text"
//                             //  title='Requested = 10&#10;In Progress = 3&#10;Delivered = 10'
//                             // title={title}
                             
//                              >As on Date <br/> <span style={{ color: "#78417C" }}>
//                                 {groupKnowledgeData > 0 ? (
//                                     <>
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/GroupKnowledgeSession ${getCurrentDate()}.xlsx`} download={`GroupKnowledgeSession ${getCurrentDate()}.xlsx`}>
//                                         {groupKnowledgeData}
//                                     </a>
//                                     </>
//                                 ) : (
//                                     <span>{groupKnowledgeData}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         <div style={{ clear: "both" }}></div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Interested <br/> <span style={{ color: "#78417C" }}>{groupKnowledgeSessionRequested}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Attended <br/> <span style={{ color: "#78417C" }}>{groupKnowledgeSessionDelivered}</span></h5>
//                         </div>
//                         <div className='count-text'>
//                         <span style={{color: 'lightslategray'}}>
//                         *Remaining women entrepreneurs could not attend the session due to various reasons
//                         </span>
//                     </div>
//                     </div>
//                 </div>

//                 <div className="col-4">
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff",
//                         height: '220px'
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                         <label className="esp-box-header-title mt-2">Expert Consultation</label>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
//                             <h5 className="esp-count-text">Target <br/> <span style={{ color: "#78417C" }}>800</span></h5>
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{expertData || 0}</span></h5> */}
//                             <h5 className="esp-count-text">As on Date <br/> <span style={{ color: "#78417C" }}>
//                                 {expertData > 0 ? (
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/ExpertConsultation ${getCurrentDate()}.xlsx`} download={`ExpertConsultation ${getCurrentDate()}.xlsx`}>
//                                         {expertData}
//                                     </a>
//                                 ) : (
//                                     <span>{expertData}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         <div style={{ clear: "both" }}></div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Requested <br/> <span style={{ color: "#78417C" }}>{expertConsultationRequested}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>In Progress <br/> <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered <br/> <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5>
//                         </div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px",paddingTop: '5px' }}>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Cancelled: <span style={{ color: "#78417C" }}>{experConsultationCancelled}</span></h5> */}
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>In Progress: <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered: <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5> */}
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div className="row mt-2 mb-4">
//                 <div className="col-4">
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff",
//                         height: '220px'
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                         <label className="esp-box-header-title mt-2">Market Connect</label>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="esp-count-text">Target <br/> <span style={{ color: "#78417C" }}>500</span></h5>
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{marketConnectData || 0}</span></h5> */}
//                             <h5 className="esp-count-text">As on Date <br/> <span style={{ color: "#78417C" }}>
//                                 {marketConnectData > 0 ? (
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/MarketConnect ${getCurrentDate()}.xlsx`} download={`MarketConnect ${getCurrentDate()}.xlsx`}>
//                                         {marketConnectData}
//                                     </a>
//                                 ) : (
//                                     <span>{marketConnectData}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         <div style={{ clear: "both" }}></div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Opportunities Offered<br/> <span style={{ color: "#78417C" }}>{marketConnectRequested}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Opportunities Availed<br/> <span style={{ color: "#78417C" }}>{marketConnectDelivered}</span></h5>
//                         </div>
//                         <div className='count-text'>
//                             <span style={{ color: 'lightslategray' }}>
//                             *Remaining women entrepreneurs could not avail the market opportunities due to some reasons
//                             </span>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="col-4">
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff",
//                         height: '220px'
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                         <label className="esp-box-header-title mt-2">Compliance</label>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="esp-count-text">Target <br/> <span style={{ color: "#78417C" }}>100</span></h5>
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{complianceData || 0}</span></h5> */}
//                             <h5 className="esp-count-text">As on Date <br/> <span style={{ color: "#78417C" }}>
//                                 {complianceData > 0 ? (
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/Compliance ${getCurrentDate()}.xlsx`} download={`Compliance ${getCurrentDate()}.xlsx`}>
//                                         {complianceData}
//                                     </a>
//                                 ) : (
//                                     <span>{complianceData}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         {/* <div style={{ clear: "both" }}></div> */}
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Requested <br/> <span style={{ color: "#78417C" }}>{complianceRequested}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>In Progress <br/> <span style={{ color: "#78417C" }}>{complianceProgress}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered <br/> <span style={{ color: "#78417C" }}>{complianceDelivered}</span></h5>
//                         </div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px",paddingTop: '5px' }}>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Cancelled: <span style={{ color: "#78417C" }}>{complianceCancellled}</span></h5> */}
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>In Progress: <span style={{ color: "#78417C" }}>{complianceProgress}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered: <span style={{ color: "#78417C" }}>{complianceDelivered}</span></h5> */}
//                         </div>
//                     </div>
//                 </div>

//                 <div className="col-4">
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff",
//                         height: '220px'
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                         <label className="esp-box-header-title mt-2">Business Loan Readiness Program</label>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
//                             <h5 className="esp-count-text">Target <br/><span style={{ color: "#78417C" }}>100</span></h5>
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{blrpData || 0}</span></h5> */}
//                             <h5 className="esp-count-text">As on Date <br/> <span style={{ color: "#78417C" }}>
//                                 {blrpData > 0 ? (
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/BLRP ${getCurrentDate()}.xlsx`} download={`BLRP ${getCurrentDate()}.xlsx`}>
//                                         {blrpData}
//                                     </a>
//                                 ) : (
//                                     <span>{blrpData}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         <div style={{ clear: "both" }}></div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Requested <br/> <span style={{ color: "#78417C" }}>{blrpRequested}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>In Progress <br/> <span style={{ color: "#78417C" }}>{blrpProgress}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered <br/> <span style={{ color: "#78417C" }}>{blrpDelivered}</span></h5>
//                         </div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px",paddingTop: '5px' }}>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Cancelled: <span style={{ color: "#78417C" }}>{blrpCancelled}</span></h5> */}
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>In Progress: <span style={{ color: "#78417C" }}>{blrpProgress}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered: <span style={{ color: "#78417C" }}>{blrpDelivered}</span></h5> */}
//                         </div>
//                     </div>
//                 </div>

//             </div>

//             {/* <div className='row mb-3 text-center'>
//                 <div className='col-12'>
//                     <div className='esp-count-text'>
//                         <span style={{color: 'red'}}>
//                         Note: The number indicates both, the services in progress and delivered.
//                         </span>
//                     </div>
//                 </div>
//             </div> */}

//             <div style={{
//                 borderBottom: "2px solid lightgray"
//             }}></div>

//             <div className="row mt-3 mb-2">
//                 <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
//                     <HistogramTotalBeneficiaryChart isLoading={isLoading} data={totalBeneChartData} />
//                 </div>

//                 <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
//                     <DeliveredResourcePieChart data={summaryData} />
//                 </div>
//             </div>

//             {/* <div className="row mt-3 mb-2">
//                 <div className="col-6">
//                     <DataPieChart data={combineData}/> 
//                 </div>

//                 <div className="col-6">
//                     <CustomHistogramChart isLoading={isLoading} data={combineData}/> 
//                 </div>
//             </div> */}

//             <div className="row mt-3 mb-2">
//                 <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
//                     {/* <DataPieChart data={combineData}/>  */}
//                     <CompliancePieChart data={filteredCompliance} />
//                 </div>

//                 <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
//                     <MarketLinkagePieChart data={filteredMarketLinkage} />
//                     {/* <CustomHistogramChart isLoading={isLoading} data={combineData}/>  */}
//                 </div>
//             </div>

//             <div className="row mt-3 mb-2">
//                 <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
//                     {/* <DataPieChart data={combineData}/>  */}
//                     {/* <CompliancePieChart data={filteredCompliance} /> */}
//                     <KnowledgeSessionPieChart data={combineData}/>
//                 </div>
//             </div>

//             {
//                 loadMore &&
//                 <>
//                     <div className="row mt-2 mb-2">
//                         <div className="col-md-12">
//                             <JpmcMainTable isLoading={isLoading} data={combineData} />
//                         </div>
//                     </div>

//                     <div className="row mt-2 mb-2">
//                         <div className="col-lg-6 col-md-12 col-sm-12">
//                             <AgeWiseJpmcTable isLoading={isLoading} data={ageWiseData} />
//                         </div>

//                         <div className="col-lg-6 col-md-12 col-sm-12">
//                             <IncomeJpmcTable isLoading={isLoading} data={businessIncData} />
//                         </div>
//                     </div>

//                     <div className="row mt-2 mb-4">
//                         <div className="col-lg-6 col-md-12 col-sm-12">
//                             <SectorWiseJpmcTable isLoading={isLoading} data={sectorWiseData} />
//                         </div>

//                         <div className="col-lg-6 col-md-12 col-sm-12">
//                             <FamilyIncomeJpmcTable isLoading={isLoading} data={familyIncData} />
//                         </div>
//                     </div>

//                     <div className="row mt-2 mb-4">
//                         <div className="col-md-12">
//                             <JpmcExpenseTable isLoading={isLoading} data={jpmcExpsData} />
//                         </div>
//                     </div>
//                 </>
//             }

//             {
//                 !loadMore &&
//                 <div className='d-flex justify-content-center mt-2 mb-3'>
//                     <button className="my-services-model-cancel-btn" onClick={() => setLoadMore(true)} >Load More</button>
//                 </div>
//             }

//         </div>
//     )
// }

// export default JpmcDashboardContainer

// import React, { useEffect, useState } from 'react'
// import ReactDatePicker from "react-datepicker";
// import { Button } from "../../common/Button/Button";
// import JpmcMainTable from './JpmcMainTable';
// import AgeWiseJpmcTable from './AgeWiseJpmcTable';
// import SectorWiseJpmcTable from './SectorWiseJpmcTable';
// import FamilyIncomeJpmcTable from './FamilyIncomeJpmcTable';
// import IncomeJpmcTable from './IncomeJpmcTable';
// import api from '../../utils/api';
// import Spinner from '../../common/Spinner/Spinner';
// import DataPieChart from './DataPieChart';
// import CustomHistogramChart from './CustomHistogramChart';
// import HistogramTotalBeneficiaryChart from './HistogramTotalBeneficiaryChart';
// import CompliancePieChart from './CompliancePieChart';
// import MarketLinkagePieChart from './MarketLinkagePieChart';
// import DeliveredResourcePieChart from './DeliveredResourcePieChart';
// import { toast } from 'react-toastify';
// import JpmcExpenseTable from './JpmcExpenseTable';
// import { DOWNLOAD_API_URL } from '../../utils/constants';
// import KnowledgeSessionPieChart from './KnowledgeSessionPieChart';
// import { Info } from 'react-feather';
// import ExpertConsultationPieChart from './ExpertConsultationPieChart';
// import downloadIcon from "../../assets/downloadsvg2.svg"
// import BlrpPieChart from './BlrpPieChart';



// const JpmcDashboardContainer = () => {

//     const [fromDate, setfromDate] = useState();
//     const [toDate, settoDate] = useState();
//     const [ageWiseData, setAgeWiseData] = useState([])
//     const [sectorWiseData, setSectorWiseData] = useState([])
//     const [familyIncData, setFamilyIncData] = useState([])
//     const [businessIncData, setBusinessIncData] = useState([])
//     const [combineData, setCombineData] = useState([])
//     const [clearClicked, setClearClicked] = useState(false);
//     const [isLoading, setIsLoading] = useState(false)
//     const [countData, setCountData] = useState("")
//     const [mobilizationCountData, setMobilizationCountData] = useState("")
//     const [totalBeneChartData, setTotalBeneChartData] = useState([])
//     const [groupKnowledgeData, setGroupKnowliedgeData] = useState()
//     const [expertData, setExpertData] = useState()
//     const [marketConnectData, setMarketConnectData] = useState()
//     const [complianceData, setComplianceData] = useState()
//     const [blrpData, setBlrpData] = useState()
//     const [loadMore, setLoadMore] = useState(false)
//     const [filteredCompliance, setFilteredCompliance] = useState([])
//     const [filteredMarketLinkage, setFilteredMarketLinkage] = useState([])
//     const [summaryData, setSummaryData] = useState([])
//     const [jpmcExpsData, setJpmcExpsData] = useState([])

//     const [complianceReportData, setComplianceReportData] = useState()
//     const [groupKnowledgeSessionReportData, setGroupKnowledgeSessionReportData] = useState()

//     const [complianceRequested, setComplianceRequested] = useState()
//     const [complianceProgress, setComplianceProgress] = useState()
//     const [complianceDelivered, setComplianceDelivered] = useState(0)
//     const [complianceCancellled, setComplianceCancelled] = useState()
//     const [allComplianceDeliveredCount, setAllComplianceDeliveredCount] = useState(0)

//     const [groupKnowledgeSessionRequested, setGroupKnowledgeSessionRequested] = useState()
//     const [groupKnowledgeSessionProgress, setGroupKnowledgeSessionProgress] = useState()
//     const [groupKnowledgeSessionDelivered, setGroupKnowledgeSessionDelivered] = useState()
//     const [allGroupKnowledgeSessionDeliveredCount, setAllGroupKnowledgeSessionDeliveredCount] = useState(0);
//     const [allBlrpDeliveredCount, setAllBlrpDeliveredCount] = useState(0)

//     const [expertConsultationRequested, setExpertConsultationRequested] = useState()
//     const [expertConsultationProgress, setExpertConsultationProgress] = useState()
//     const [expertConsultationDelivered, setExpertConsultationDelivered] = useState(0)
//     const [experConsultationCancelled, setExpertConsultationCancelled] = useState()
//     const [allFilteredExpertConsultation, setAllFilteredExpertConsultation] = useState([])
//     const [allExpertConsultationDeliveredCount, setAllExpertConsultationDeliveredCount] = useState(0);

//     const [marketConnectRequested, setMarketConnectRequested] = useState()
//     const [marketConnectProgress, setMarketConnectProgress] = useState()
//     const [marketConnectDelivered, setMarketConnectDelivered] = useState()
//     const [allMarketConnectDeliveredCount, setAllMarketConnectDeliveredCount] = useState(0)

//     const [blrpRequested, setBlrpRequested] = useState()
//     const [blrpProgress, setBlrpProgress] = useState()
//     const [blrpDelivered, setBlrpDelivered] = useState()
//     const [blrpCancelled, setBlrpCancelled] = useState()

//     const [groupknowledgesession, setgroupknowledgesession] = useState("")
//     const [groupknowledgeAsOnDate, setGroupknowledgeAsOnDate] = useState("");

//     const [marketlinkagesession, setmarketlinkagesession] = useState([])
//     const [marketLinkageSessionAsOnDate, setMarketLinkageSessionAsOnDate] = useState("");

//     const [compliancesession, setcompliancesession] = useState([])
//     const [complianceAsOnDate, setComplianceAsOnDate] = useState("");

//     const [expertconsultation, setexpertconsultation] = useState([])
//     const [expertConsultationAsOnDate, setExpertConsultationAsOnDate] = useState("");

//     const [blrpsession, setblrpsession] = useState([])
//     const [blrpSessionAsOnDate, setBlrpSessionAsOnDate] = useState("")
//     const [blrpPieChartData, setBlrpPieChartData] = useState([])

//     const [eligibleReportResourceAvailed, setEligibleReportResourceAvailed] = useState(null);

//     const [totalResourcesDelivered, setTotalResourcesDelivered] = useState(0);

//     useEffect(() => {
//         const mobileWidthBreakpoint = 768;

//         const displayToastForMobileResolution = () => {
//             if (window.innerWidth < mobileWidthBreakpoint) {
//                 toast("This dashboard is best viewable in a desktop browser.", {
//                     autoClose: 5000,
//                     type: toast.TYPE.ERROR,
//                 });
//             }
//         };

//         displayToastForMobileResolution();

//         window.addEventListener('resize', displayToastForMobileResolution);

//         return () => window.removeEventListener('resize', displayToastForMobileResolution);
//     }, []);

//     const ondatechange = (key, date) => {
//         if (key === "fromDate") {
//             setfromDate(date)

//         } else if (key === "toDate") {
//             settoDate(date)

//         }
//     };

//     const dateAdjusted = (date) => {
//         let toDateAdjusted;
//         if (date) {
//             toDateAdjusted = new Date(date);

//             toDateAdjusted = new Date(
//                 toDateAdjusted.setTime(
//                     toDateAdjusted.getTime() + (29.5 * 60 * 60 * 1000 - 1000)
//                 )
//             );
//         }
//         return toDateAdjusted;
//     }

//     const dateAdjusted1 = (date) => {
//         let toDateAdjusted;
//         if (date) {
//             toDateAdjusted = new Date(date);

//             toDateAdjusted = new Date(
//                 toDateAdjusted.setTime(
//                     toDateAdjusted.getTime() + (5.5 * 60 * 60 * 1000)
//                 )
//             );
//         }
//         return toDateAdjusted;
//     }

//     const filterAndCombineData = (data, keyToCompare) => {
//         const combinedData = {};

//         data.forEach(entry => {
//             const key = `${entry[keyToCompare]}_${entry.sResourceDisplayName}`;

//             if (combinedData[key]) {
//                 combinedData[key].sMobile_count += entry.sMobile_count;
//             } else {
//                 combinedData[key] = { ...entry };
//             }
//         });

//         const combinedDataArray = Object.values(combinedData);

//         return combinedDataArray;
//     };

//     // useEffect(() => {
//     //     setSummaryData([
//     //         ["Expert Consultation", expertConsultationDelivered],
//     //         ["Market Connect", marketConnectDelivered],
//     //         ["Group Knowledge Session", groupKnowledgeSessionDelivered],
//     //         ["BLRP", blrpDelivered],
//     //         ["Compliance", complianceDelivered]
//     //     ])
//     // }, [groupKnowledgeSessionDelivered, complianceDelivered, expertConsultationDelivered, marketConnectDelivered, blrpDelivered])

//     const getTableData = () => {
//         setIsEligibleLoading(true);
//         setIsGroupKnowledgeSessionLoading(true);
//         setIsExpertConsultationLoading(true);
//         setIsMarketConnectLoading(true);
//         setIsComplianceLoading(true);
//         setIsBlrpLoading(true);

//         setIsTotalBeneficiaryChartLoading(true);

//         setIsGetAllDeliveredCountLoading(true);
//         setIsCompliancesChartDataLoading(true);
//         setIsMarketConnectChartDataLoading(true);
//         setIsExpertConsultationChartDataLoading(true);
//         setGroupKnowledgeSessionChartDataLoading(true);
//         setBlrpPieChartDataLoading(true);

//         let filterParameters = {}

//         if (fromDate) {
//             filterParameters.fromDate = dateAdjusted1(fromDate)
//         }

//         if (toDate) {
//             filterParameters.toDate = dateAdjusted(toDate)
//         }

//         console.log("Filter", filterParameters)
//         setIsLoading(true)

//         let payload = {
//             api_key : "r54B?rHXUE7v%$9t",
//             // api_key: "82mqEyJnct4kzC8y",

//         }

//         const { tempMobilizationCount } = api.mobilizationCountApi(payload)
//             .then(({ data }) => {
//                 setMobilizationCountData(data.data.total_count)
//             })
//             .catch(err => {
//                 console.log("Error",err);
//             })

//         const { tempCountData } = api.jpmcCountData(filterParameters)
//             .then(({ data }) => {
//                 console.log("COUNT", data.count)
//                 setCountData(data.count)
//                 setIsEligibleLoading(false);
//             })

//         const { tempTotalBeneficiaryData } = api.totalBeneficiaryChartData(filterParameters)
//             .then(({ data }) => {
//                 console.log("Chart Data", data)
//                 setTotalBeneChartData(data)
//                 setIsTotalBeneficiaryChartLoading(false);
//             })

//         const { tempJpmcExpenseData } = api.jpmcExpenseTableData(filterParameters)
//             .then(({ data }) => {
//                 console.log("Expense Data", data)
//                 setJpmcExpsData(data.data)
//             })

//         const { tempComplianceReport } = api.getComplianceReportAPI(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Report Compliance", data)
//                 console.log("Data compliance Session Report", data);
//                 console.log("filterParameters", filterParameters)
//                 const fullPath = data.generated_file;
//                 const parts = fullPath.split('/');
//                 const filename = parts[parts.length - 1];

//                 setComplianceAsOnDate(`${filename}`);

//                 console.log("Generated File Path:", `/${filename}`);
//             })

//         const { tempExpertConsultaionReport } = api.getExpertConsultationReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Expert consultation as on date", data)
//                 console.log("filterParameters", filterParameters)
//                 const fullPath = data.generated_file;
//                 const parts = fullPath.split('/');
//                 const filename = parts[parts.length - 1];

//                 setExpertConsultationAsOnDate(`${filename}`);

//                 console.log("Generated File Path:", `/${filename}`);
//             })

//         const { tempMobilizationReport } = api.getMobilizationReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Report Mobilization", data)
//             })

//         const { tempBlrpReport } = api.getBlrpReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data blrp all data", data)
//                 console.log("filterParameters", filterParameters)
//                 const fullPath = data.generated_file;
//                 const parts = fullPath.split('/');
//                 const filename = parts[parts.length - 1];

//                 setBlrpSessionAsOnDate(`${filename}`);

//                 console.log("Generated File Path:", `/${filename}`);
//             })

//         const { tempGroupKnowledgeReport } = api.getGroupKnowledgeReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Group Knowledge Session Report", data);
//                 console.log("filterParameters", filterParameters)
//                 const fullPath = data.generated_file;
//                 const parts = fullPath.split('/');
//                 const filename = parts[parts.length - 1];

//                 setGroupknowledgeAsOnDate(`${filename}`);

//                 console.log("Generated File Path:", `/${filename}`);
//             })

//         const { tempGroupKnowledgeSessionReport } = api.getGroupKnowledgeSessionReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Group Knowledge Session Report", data);
//                 console.log("filterParameters", filterParameters)
//                 const fullPath = data.generated_file;
//                 const parts = fullPath.split('/');
//                 const filename = parts[parts.length - 1];

//                 setgroupknowledgesession(`${filename}`);

//                 console.log("Generated File Path:", `/${filename}`);
//             });

//         const { tempMarketLinkageSessionReport } = api.getMarketLinkageSessionReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Group Knowledge Session Report", data);
//                 console.log("filterParameters", filterParameters)
//                 const fullPath = data.generated_file;
//                 const parts = fullPath.split('/');
//                 const filename = parts[parts.length - 1];

//                 setmarketlinkagesession(`${filename}`);

//                 console.log("Generated File Path:", `/${filename}`);
//             });
//         const { tempComplianceSessionReport } = api.getComplianceSessionReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data compliance sessio Report", data);
//                 console.log("filterParameters", filterParameters)
//                 const fullPath = data.generated_file;
//                 const parts = fullPath.split('/');
//                 const filename = parts[parts.length - 1];

//                 setcompliancesession(`${filename}`);

//                 console.log("Generated File Path:", `/${filename}`);
//             });
//         const { tempExpertConsultationSessionReport } = api.getExpertConsultationSessionReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Group Knowledge Session Report", data);
//                 console.log("filterParameters", filterParameters)
//                 const fullPath = data.generated_file;
//                 const parts = fullPath.split('/');
//                 const filename = parts[parts.length - 1];

//                 setexpertconsultation(`${filename}`);

//                 console.log("Generated File Path:", `/${filename}`);
//             });
//         const { tempblrpSessionReport } = api.getblrpSessionReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Group Knowledge Session Report", data);
//                 console.log("filterParameters", filterParameters)
//                 const fullPath = data.generated_file;
//                 const parts = fullPath.split('/');
//                 const filename = parts[parts.length - 1];

//                 setblrpsession(`${filename}`);

//                 console.log("Generated File Path:", `/${filename}`);
//             });




//         const { tempMarketLinkage } = api.getMarketLinkageReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Report MarketLinkage", data)
//                 console.log("Data market connect as on date Report", data);
//                 console.log("filterParameters", filterParameters)
//                 const fullPath = data.generated_file;
//                 const parts = fullPath.split('/');
//                 const filename = parts[parts.length - 1];

//                 setMarketLinkageSessionAsOnDate(`${filename}`);

//                 console.log("Generated File Path:", `/${filename}`);
//             })

//         const { tempJpmcAllData } = api.getJpmcAllData(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Report All", data);
//             })
//         let complianceCount = 0;
//         let complianceCountDelivered = 0;
//         let complianceCountRequested = 0;
//         let complianceCountProgress = 0;
//         let complianceCountCancelled = 0;

//         let groupKnowledgeSessionCount = 0;
//         let groupKnowledgeSessionCountDelivered = 0;
//         let groupKnowledgeSessionCountRequested = 0;
//         let groupKnowledgeSessionCountProgress = 0;
//         let groupKnowledgeSessionCountCancelled = 0;

//         let expertConsultationCount = 0;
//         let expertConsultationCountDelivered = 0;
//         let expertConsultationCountRequested = 0;
//         let expertConsultationCountProgress = 0;
//         let expertConsultationCountCancelled = 0;

//         let marketConnectCount = 0;
//         let marketConnectCountDelivered = 0;
//         let marketConnectCountRequested = 0;
//         let marketConnectCountProgress = 0;
//         let marketConnectCountCancelled = 0;

//         let blrpCount = 0;
//         let blrpCountDelivered = 0;
//         let blrpCountRequested = 0;
//         let blrpCountProgress = 0;
//         let blrpCountCancelled = 0;

//         let generatedFilePath;



//         const { tempComplianceReportData } = api.getComplianceReportDataAPI(filterParameters)
//             .then(({ data }) => {
//                 console.log("ComplianceData", data)
//                 setComplianceReportData(data.data)

//                 // // Old Working
//                 // data.data.forEach(item => {
//                 //     complianceCount += item.sMobile_count || 0;

//                 //     if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
//                 //         complianceCountCancelled += item.sMobile_count || 0;
//                 //     }

//                 //     if (item.refCurrentStateSPM === "") {
//                 //         if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
//                 //             item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
//                 //             item.refSRStateLPM === "Quotation Sent") {
//                 //             complianceCountRequested += item.sMobile_count || 0;
//                 //         }

//                 //         if (item.refSRStateLPM === "Payment Received") {
//                 //             complianceCountProgress += item.sMobile_count || 0;
//                 //         }
//                 //     }

//                 //     if (item.refCurrentStateSPM !== "") {
//                 //         if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
//                 //             complianceCountProgress += item.sMobile_count || 0;
//                 //         }

//                 //         if (item.refCurrentStateSPM === "Delivered") {
//                 //             complianceCountDelivered += item.sMobile_count || 0;
//                 //         }
//                 //     }
//                 // })

//                 // New with changed status for interested
//                 data.data.forEach(item => {
//                     complianceCount += item.sMobile_count || 0;

//                     if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
//                         complianceCountCancelled += item.sMobile_count || 0;
//                     }

//                     if (item.refCurrentStateSPM === "") {
//                         if (item.refSRStateLPM === "Requested") {
//                             complianceCountRequested += item.sMobile_count || 0;
//                         }

//                         // if (item.refSRStateLPM === "Payment Received") {
//                         //     complianceCountProgress += item.sMobile_count || 0;
//                         // }
//                     }

//                     if (item.refCurrentStateSPM !== "") {
//                         if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
//                             complianceCountProgress += item.sMobile_count || 0;
//                         }

//                         if (item.refCurrentStateSPM === "Delivered") {
//                             complianceCountDelivered += item.sMobile_count || 0;
//                         }
//                     }
//                 })

//                 setComplianceDelivered(complianceCountDelivered)
//                 setComplianceRequested(complianceCountRequested)
//                 setComplianceProgress(complianceCountProgress)
//                 setComplianceCancelled(complianceCountCancelled)
//                 setComplianceData(complianceCount)
//                 setIsComplianceLoading(false);
//             })

//         const { tempGroupKnowledgeReportData } = api.getGroupKnowledgeReportData(filterParameters)
//             .then(({ data }) => {
//                 setGroupKnowledgeSessionReportData(data.data)
//                 // // old working
//                 // data.data.forEach(item => {
//                 //     groupKnowledgeSessionCount += item.sMobile_count || 0;
//                 //     if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
//                 //         groupKnowledgeSessionCountRequested += item.sMobile_count || 0;
//                 //     }

//                 //     if (item.refCurrentStateSPM === "Delivered") {
//                 //         groupKnowledgeSessionCountDelivered += item.sMobile_count || 0;
//                 //     }
//                 // })

//                 // new with status changed for interested 
//                 data.data.forEach(item => {
//                     groupKnowledgeSessionCount += item.sMobile_count || 0;

//                     if(item.refCurrentStateSPM === "" && item.refSRStateLPM === "Requested"){
//                         groupKnowledgeSessionCountRequested += item.sMobile_count || 0;
//                     }

//                     if (item.refCurrentStateSPM === "Delivered") {
//                         groupKnowledgeSessionCountDelivered += item.sMobile_count || 0;
//                     }
//                 })

//                 setGroupKnowliedgeData(groupKnowledgeSessionCount)
//                 setGroupKnowledgeSessionRequested(groupKnowledgeSessionCountRequested)
//                 setGroupKnowledgeSessionDelivered(groupKnowledgeSessionCountDelivered)

//                 setIsGroupKnowledgeSessionLoading(false)
//             })

//         const { tempExpertConsultaionReportData } = api.getExpertConsultationReportData(filterParameters)
//             .then(({ data }) => {

//                 // //old working
//                 // data.data.forEach(item => {
//                 //     expertConsultationCount += item.sMobile_count || 0;

//                 //     if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
//                 //         expertConsultationCountCancelled += item.sMobile_count || 0;
//                 //     }

//                 //     if (item.refCurrentStateSPM === "") {
//                 //         if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
//                 //             item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
//                 //             item.refSRStateLPM === "Quotation Sent") {
//                 //             expertConsultationCountRequested += item.sMobile_count || 0;
//                 //         }

//                 //         if (item.refSRStateLPM === "Payment Received") {
//                 //             expertConsultationCountProgress += item.sMobile_count || 0;
//                 //         }
//                 //     }

//                 //     if (item.refCurrentStateSPM !== "") {
//                 //         if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
//                 //             expertConsultationCountProgress += item.sMobile_count || 0;
//                 //         }

//                 //         if (item.refCurrentStateSPM === "Delivered") {
//                 //             expertConsultationCountDelivered += item.sMobile_count || 0;
//                 //         }
//                 //     }
//                 // })

//                 // New with some status changed for Interesed count
//                 data.data.forEach(item => {
//                     expertConsultationCount += item.sMobile_count || 0;

//                     if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
//                         expertConsultationCountCancelled += item.sMobile_count || 0;
//                     }

//                     if (item.refCurrentStateSPM === "") {
//                         if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
//                             item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
//                             item.refSRStateLPM === "Quotation Sent") {
//                             expertConsultationCountRequested += item.sMobile_count || 0;
//                         }
//                     }

//                     if (item.refCurrentStateSPM !== "") {
//                         if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
//                             expertConsultationCountProgress += item.sMobile_count || 0;
//                         }

//                         if (item.refCurrentStateSPM === "Delivered") {
//                             expertConsultationCountDelivered += item.sMobile_count || 0;
//                         }
//                     }
//                 })

//                 setExpertData(expertConsultationCount);
//                 setExpertConsultationRequested(expertConsultationCountRequested)
//                 setExpertConsultationProgress(expertConsultationCountProgress) // Payment Received k baad ke saare status lene hain
//                 setExpertConsultationDelivered(expertConsultationCountDelivered)
//                 setExpertConsultationCancelled(expertConsultationCountCancelled)
//                 setIsExpertConsultationLoading(false)
//             })

//         const { tempMarketLinkageData } = api.getMarketLinkageReportData(filterParameters)
//             .then(({ data }) => {
//                 // // old working
//                 // data.data.forEach(item => {
//                 //     marketConnectCount += item.sMobile_count || 0;
//                 //     if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
//                 //         marketConnectCountRequested += item.sMobile_count || 0;
//                 //     }

//                 //     if (item.refCurrentStateSPM === "Delivered") {
//                 //         marketConnectCountDelivered += item.sMobile_count || 0;
//                 //     }
//                 // })

//                 // New with some status changed for Interested count
//                 data.data.forEach(item => {
//                     marketConnectCount += item.sMobile_count || 0;

//                     if (item.refCurrentStateSPM === "" && item.refSRStateLPM === "Requested") {
//                         marketConnectCountRequested += item.sMobile_count || 0;
//                     }

//                     if (item.refCurrentStateSPM === "Delivered") {
//                         marketConnectCountDelivered += item.sMobile_count || 0;
//                     }
//                 })

//                 setMarketConnectData(marketConnectCount);
//                 setMarketConnectRequested(marketConnectCountRequested)
//                 setMarketConnectDelivered(marketConnectCountDelivered)
//                 setIsMarketConnectLoading(false);
//             })

//         const { tempBlrpReportData } = api.getBlrpReportData(filterParameters)
//             .then(({ data }) => {

//                 // // Old working 
//                 // data.data.forEach(item => {
//                 //     blrpCount += item.sMobile_count || 0;

//                 //     if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
//                 //         blrpCountCancelled += item.sMobile_count || 0;
//                 //     }

//                 //     if (item.refCurrentStateSPM === "") {
//                 //         if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
//                 //             item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
//                 //             item.refSRStateLPM === "Quotation Sent") {
//                 //             blrpCountRequested += item.sMobile_count || 0;
//                 //         }

//                 //         if (item.refSRStateLPM === "Payment Received") {
//                 //             blrpCountProgress += item.sMobile_count || 0;
//                 //         }
//                 //     }

//                 //     if (item.refCurrentStateSPM !== "") {
//                 //         if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
//                 //             blrpCountProgress += item.sMobile_count || 0;
//                 //         }

//                 //         if (item.refCurrentStateSPM === "Delivered") {
//                 //             blrpCountDelivered += item.sMobile_count || 0;
//                 //         }
//                 //     }
//                 // })

//                 // New with updated status for Interest counts
//                 data.data.forEach(item => {
//                     blrpCount += item.sMobile_count || 0;

//                     if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
//                         blrpCountCancelled += item.sMobile_count || 0;
//                     }

//                     if (item.refCurrentStateSPM === "") {
//                         if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
//                             item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
//                             item.refSRStateLPM === "Quotation Sent") {
//                             blrpCountRequested += item.sMobile_count || 0;
//                         }

//                         // if (item.refSRStateLPM === "Payment Received") {
//                         //     blrpCountProgress += item.sMobile_count || 0;
//                         // }

//                         if(item.refSRStateLPM === "Requested"){
//                             blrpCountProgress += item.sMobile_count || 0;
//                         }
//                     }

//                     if (item.refCurrentStateSPM !== "") {
//                         // if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
//                         //     blrpCountProgress += item.sMobile_count || 0;
//                         // }

//                         if (item.refCurrentStateSPM === "Delivered") {
//                             blrpCountDelivered += item.sMobile_count || 0;
//                         }
//                     }
//                 })

//                 setBlrpData(blrpCount)
//                 setBlrpRequested(blrpCountRequested)
//                 setBlrpProgress(blrpCountProgress)
//                 setBlrpDelivered(blrpCountDelivered) // As On Date
//                 setBlrpCancelled(blrpCountCancelled)
//                 setIsBlrpLoading(false);

//             })


//         // const { tempCombineData } = api.mainTableData(filterParameters)
//         //     .then(({ data }) => {

//         //         // let onlyDeliveredData = data?.filter(obj =>{
//         //         //     return obj?.refCurrentStateSPM ===  "Delivered";
//         //         // });
//         //         // console.log(onlyDeliveredData, ">>>>onlyDeliveredData");
                

//         //         // setCombineData(onlyDeliveredData)
//         //         // setGroupKnowledgeSessionChartDataLoading(false)

//         //         // const ageData = filterAndCombineData(onlyDeliveredData, 'age')
//         //         // setAgeWiseData(ageData)

//         //         // const sectorData = filterAndCombineData(onlyDeliveredData, 'sBusinessSector')
//         //         // setSectorWiseData(sectorData)

//         //         // const BusinessIncData = filterAndCombineData(onlyDeliveredData, 'sBusinessTurnover')
//         //         // setBusinessIncData(BusinessIncData)

//         //         // const FamIncData = filterAndCombineData(onlyDeliveredData, 'sFamilyIncome')
//         //         // setFamilyIncData(FamIncData)

//         //         // const filteredComplianceData = data.filter((item) => {
//         //         //     if (item.sResourceDisplayName === 'Shop Act Intimation' || item.sResourceDisplayName === 'Udyam Registration' || item.sResourceDisplayName === 'FSSAI Licence' || item.sResourceDisplayName === 'Copyright Registration'
//         //         //         || item.sResourceDisplayName === 'Trademark Registration' || item.sResourceDisplayName === 'FSSAI Registration' || item.sResourceDisplayName === 'GST Registration') {
//         //         //         return item;
//         //         //     }
//         //         // })

//         //         // const filteredMarketLinkageData = data.filter((item) => {
//         //         //     if (item.sResourceDisplayName === 'Bulk Buyer' || item.sResourceDisplayName === 'Exhibition' || item.sResourceDisplayName === 'Corporate Linkage' || item.sResourceDisplayName === 'Export' || item.sResourceDisplayName === 'Ecommerce' || item.sResourceDisplayName === 'Shop in Shop') {
//         //         //         return item
//         //         //     }
//         //         // })

//         //         // const filteredMarketLinkageData = data.filter((item) => {
//         //         //     if (item.sResourceID === 'MKTLINKAGECORPLINKAGE' || item.sResourceID === 'MKTLINKAGEEXHIBITION' || item.sResourceID === 'MKTLINKAGEBULKBUYER' || item.sResourceID === 'MKTLINKAGEEXPORT' || item.sResourceID === 'MKTLINKAGEECOM' || item.sResourceID === 'MKTLINKAGESHOPINSHOP' || item.sResourceID === "DIGITALVISKIT" ) {
//         //         //         return item
//         //         //     }
//         //         // })

//         //         // setFilteredCompliance(filteredComplianceData)
//         //         // setFilteredMarketLinkage(filteredMarketLinkageData)
//         //         // setIsCompliancesChartDataLoading(false);
//         //         // setIsMarketConnectChartDataLoading(false);
//         //     })

//             // // below is dummy expertConsultationApi, in mainTableData API i need sPackage_title key for all expert consultation services
//             // // and then i can put below logic in mainTableData api for calculating all expert consultation delivered
//             // const {tempXpertConsultationCombineData} = api.dummyExpertConsultationMainTableData(filterParameters)
//             //     .then(({data}) =>{
//             //         console.log(data?.Response, ">>>>all expert consultation services");
//             //         let packageTitles = [
//             //             'Expert Clinic_JPMC_Market Linkage',
//             //             'Expert Clinic_JPMC_Compliances',
//             //             'Expert Clinic_JPMC_Loan Readiness',
//             //             'Expert Clinic_JPMC_Rahul Limaye',
//             //             'Expert Clinic_JPMC_Dr.Anand Godse',
//             //             'Expert Clinic_JPMC_Kavita_Awasthee',
//             //             'Expert Clinic_JPMC_Generic',
//             //             'Expert Clinic_JPMC_Bhaskar',
//             //             'Expert Clinic_JPMC_Bhagyashri Mhatre',
//             //             'Expert Clinic_JPMC_Manisha Chandak',
//             //             'Expert Clinic_JPMC_Leena Khandekar',
//             //             'Expert Clinic_JPMC_Sudhir Gijare',
//             //             'Business Loan Sarathi Package',
//             //         ];

//             //         let allXpert = data.Response.filter((obj) => obj.sResourceID == 'EXPRTCONSULT');

//             //         let allDelivered = allXpert.filter(
//             //             (obj) => obj.refCurrentStateSPM == 'Delivered'
//             //         );

//             //         const filteredExpertConsultation = allDelivered.filter(obj => {
//             //             if(packageTitles.includes(obj.sPackageOfferTitle)){
//             //                 return obj
//             //             }
//             //         })

//             //         setAllFilteredExpertConsultation(filteredExpertConsultation)
//             //     }).catch(err=>{
//             //         console.log(err,  ">>>Errr");
//             //     })

//             // below original
//             const {tempExpertConsultationAllData} = api.allExpertConsultationServices(filterParameters).then(({data}) =>{
//                 console.log(data?.Response, ">>>>all expert consultation services");
//                 // let packageTitles = [
//                 //     'Expert Clinic_JPMC_Market Linkage',
//                 //     'Expert Clinic_JPMC_Compliances',
//                 //     'Expert Clinic_JPMC_Loan Readiness',
//                 //     'Expert Clinic_JPMC_Rahul Limaye',
//                 //     'Expert Clinic_JPMC_Dr.Anand Godse',
//                 //     'Expert Clinic_JPMC_Kavita_Awasthee',
//                 //     'Expert Clinic_JPMC_Generic',
//                 //     'Expert Clinic_JPMC_Bhaskar',
//                 //     'Expert Clinic_JPMC_Bhagyashri Mhatre',
//                 //     'Expert Clinic_JPMC_Manisha Chandak',
//                 //     'Expert Clinic_JPMC_Leena Khandekar',
//                 //     'Expert Clinic_JPMC_Sudhir Gijare',
//                 //     'Business Loan Sarathi Package'
//                 // ];

//                 const filteredDeliveredExpertConsultation = data?.Response.filter(item => {
//                     if((item.sResourceID === "EXPRTCONSULT" || item.sResourceID === "LTEXPCOACH") && item.refCurrentStateSPM == "Delivered"){
//                         return item
//                     }
//                 });

//                 setAllFilteredExpertConsultation(filteredDeliveredExpertConsultation)
//                 setIsExpertConsultationChartDataLoading(false);
//             }).catch(err =>{
//                 console.log("ERROR: error in getting all expert consultration services", err);
//                 setIsExpertConsultationChartDataLoading(false);
//             })

//             // piechart data for Compliance
//             const {tempComplianceAllData} = api.allComplianceServices(filterParameters).then(({data}) => {
//                 console.log(">>>>allcomplianceapi called");
                
//                 const filteredComplianceData = data?.Response.filter((item) => {
//                     if (item.sResourceDisplayName === 'Shop Act Intimation' || item.sResourceDisplayName === 'Udyam Registration' || item.sResourceDisplayName === 'FSSAI Licence' || item.sResourceDisplayName === 'Copyright Registration'
//                         || item.sResourceDisplayName === 'Trademark Registration' || item.sResourceDisplayName === 'FSSAI Registration' || item.sResourceDisplayName === 'GST Registration') {
//                         return item;
//                     }
//                 })

//                 console.log(filteredComplianceData, ">>>filteredComplianceData");
                

//                 let allComplianceDelivered = filteredComplianceData.filter(item =>{
//                     if(item.refCurrentStateSPM == "Delivered"){
//                         return item
//                     }
//                 })

//                 console.log(allComplianceDelivered, ">>>All compliance delivered")

//                 setFilteredCompliance(allComplianceDelivered);
//                 setIsCompliancesChartDataLoading(false);
//             }).catch(err =>{
//                 console.log("ERROR: error in getting all compliance services", err);
//                 setIsCompliancesChartDataLoading(false);
//             })

//             // piechart data for group knowledge
//             const {tempGroupKnowledgeAllData} = api.allGroupKnowledgeServices(filterParameters).then(({data}) => {
//                 const filteredDeliveredGroupKnowledgeData = data?.Response.filter(item => {
//                     if(item.sResourceID === "GRPEXPRTCONSULT" && item.refCurrentStateSPM == "Delivered"){
//                         return item
//                     }
//                 });

//                 setCombineData(filteredDeliveredGroupKnowledgeData);
//                 setGroupKnowledgeSessionChartDataLoading(false);
//             }).catch(err =>{
//                 console.log("ERROR: error in getting all group knowledge services", err);
//                 setGroupKnowledgeSessionChartDataLoading(false);
//             })

//             // piechart data for market connect
//             const {tempMarketConnectAllData} = api.allMarketConnectServices(filterParameters).then(({data}) => {
//                 const filteredMarketLinkageData = data?.Response.filter((item) => {
//                     if (item.sResourceID === 'MKTLINKAGECORPLINKAGE' || item.sResourceID === 'MKTLINKAGEEXHIBITION' || item.sResourceID === 'MKTLINKAGEBULKBUYER' || item.sResourceID === 'MKTLINKAGEEXPORT' || item.sResourceID === 'MKTLINKAGEECOM' || item.sResourceID === 'MKTLINKAGESHOPINSHOP' || item.sResourceID === "DIGITALVISKIT" ) {
//                         return item
//                     }
//                 })

//                 const allMarketConnectDelivered = filteredMarketLinkageData.filter(item =>{
//                     if(item.refCurrentStateSPM == "Delivered"){
//                         return item
//                     }
//                 })

//                 setFilteredMarketLinkage(allMarketConnectDelivered);
//                 setIsMarketConnectChartDataLoading(false);
//             }).catch(err =>{
//                 console.log("ERROR: error in getting all market connect services", err);
//                 setIsMarketConnectChartDataLoading(false);
//             })

//             const {} = api.allBLRPServices(filterParameters).then(({data}) => {
//                 const filteredBlrpData = data?.Response.filter(item =>{
//                     if(item.sResourceID === "FUNDRDYPRPSL" || item.sResourceID === "EXPRTCONSULT"){
//                         return item;
//                     }
//                 })

//                 const allDeliveredBlrp = filteredBlrpData?.filter(item => {
//                     if(item.refCurrentStateSPM === "Delivered"){
//                         return item
//                     }
//                 })

//                 // const dummyAllDeliveredBlrp = [
//                 //     {
//                 //         "dtCreated": "2025-02-14T10:46:23",
//                 //         "nResourceInstanceId": 225537,
//                 //         "sMobile": "9923810825",
//                 //         "sResourceID": "EXPRTCONSULT",
//                 //         "ExpertName": "Xpert Cliniq",
//                 //         "sResourceDisplayName": "toursandtravels",
//                 //         "sBusinessSector": 21,
//                 //         "age": "Upto 5 lakhs",
//                 //         "sFamilyIncome": "Upto 5 lakhs",
//                 //         "sBusinessTurnover": "Requested",
//                 //         "refSRStateLPM": "Delivered",
//                 //         "refCurrentStateSPM": "Delivered"
//                 //     },
//                 //     {
//                 //         "dtCreated": "2025-02-14T10:57:38",
//                 //         "nResourceInstanceId": 225540,
//                 //         "sMobile": "9923810825",
//                 //         "sResourceID": "EXPRTCONSULT",
//                 //         "ExpertName": "Xpert Cliniq",
//                 //         "sResourceDisplayName": "toursandtravels",
//                 //         "sBusinessSector": 21,
//                 //         "age": "Upto 5 lakhs",
//                 //         "sFamilyIncome": "Upto 5 lakhs",
//                 //         "sBusinessTurnover": "Requested",
//                 //         "refSRStateLPM": "Delivered",
//                 //         "refCurrentStateSPM": "Delivered"
//                 //     }
//                 // ]

//                 setBlrpPieChartData(allDeliveredBlrp)
//                 setBlrpPieChartDataLoading(false);
//                 console.log(allDeliveredBlrp, ">>>allDeliveredBlrp")
//                 console.log(filteredBlrpData, ">>>filteredBlrpData")
//             }).catch(err=> {
//                 console.error("Error getting blrp piechart")
//                 setBlrpPieChartDataLoading(false);
//             })


//         const {tempAllJPMCdeliveredCount} = api.allJpmcDeliveredCounts(filterParameters).then(({data}) =>{
//             console.log(data, ">>>all jpmc delivered counts");

//             const {Compliances_count, ExpertConsultations_count, MarketOpportunities_count, KnowledgeSessions_count, LoanReadiness_count}= data
//             setAllComplianceDeliveredCount(Compliances_count);
//             setAllExpertConsultationDeliveredCount(ExpertConsultations_count)
//             setAllMarketConnectDeliveredCount(MarketOpportunities_count)
//             setAllGroupKnowledgeSessionDeliveredCount(KnowledgeSessions_count)
//             setAllBlrpDeliveredCount(LoanReadiness_count)

//             const totalResourceCount = Compliances_count + ExpertConsultations_count + MarketOpportunities_count + KnowledgeSessions_count + LoanReadiness_count;

//             let summaryData = [
//                 ["Expert Consultation", ExpertConsultations_count],
//                 ["Market Connect", MarketOpportunities_count],
//                 ["Group Knowledge Session", KnowledgeSessions_count],
//                 ["Compliance", Compliances_count],
//                 ["Business Loan Readiness", LoanReadiness_count]
//             ]
//             setSummaryData(summaryData)

//             setTotalResourcesDelivered(totalResourceCount)
//             setIsGetAllDeliveredCountLoading(false);
//         }).catch(err =>{
//             console.log("Err geting delivered counts", err); 
//         })

//         const {tempEligibleReportResourceAvailed} = api.eligibleReportResourceAvailed(filterParameters).then(({data}) =>{
//             console.log(data, ">>>>eligibleReportResourceAvailed data");
//             let downloadUrl = data?.generated_file;
//             let downloadUrlSplit = downloadUrl?.split("/");
//             let fileName = downloadUrlSplit[downloadUrlSplit?.length - 1];
//             console.log(fileName, ">>>>eligibleReportResourceAvailed file name");
//             setEligibleReportResourceAvailed(`/${fileName}`)
//         }).catch(err =>{
//             console.log("ERROR: error getting eligible resource availed data", err);
            
//         })


//     }


//     useEffect(() => {
//         getTableData()
//     }, [])

//     const handleSearch = () => {
//         // setAgeWiseData([])
//         // setSectorWiseData([])
//         // setBusinessIncData([])
//         // setFamilyIncData([])
//         // setCombineData([])
//         // setTotalBeneChartData([])
//         getTableData()
//         // setJpmcExpsData([])
//     }

//     const handleClear = () => {
//         setfromDate()
//         settoDate()
//         setAgeWiseData([])
//         setSectorWiseData([])
//         setBusinessIncData([])
//         setFamilyIncData([])
//         setCombineData([])
//         setTotalBeneChartData([])
//         setJpmcExpsData([])
//         setClearClicked(true);
//     }


//     useEffect(() => {
//         if (clearClicked) {
//             getTableData();
//             setClearClicked(false);
//         }
//     }, [clearClicked]);

//     function getCurrentDate() {
//         const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//         const today = new Date();
//         const day = String(today.getDate()).padStart(2, '0');
//         const month = months[today.getMonth()];
//         const year = today.getFullYear();
//         return `${day}${month}${year}`;
//     }

//     const currentDate = getCurrentDate();
//     // const title = `Interested = ${groupKnowledgeSessionRequested}&#10;Attended = ${groupKnowledgeSessionDelivered}`;
//     const title = "Interested:" + groupKnowledgeSessionRequested + "\n" + "Attended:" + groupKnowledgeSessionDelivered


//     // below all loaders states
//     const [isEligibleLoading, setIsEligibleLoading] = useState(false);
//     const [isGroupKnowledgeSessionLoading, setIsGroupKnowledgeSessionLoading] = useState(false);
//     const [isExpertConsultationLoading, setIsExpertConsultationLoading] = useState(false);
//     const [isMarketConnectLoading, setIsMarketConnectLoading] = useState(false);
//     const [isComplianceLoading, setIsComplianceLoading] = useState(false);
//     const [isBlrpLoading, setIsBlrpLoading] = useState(false);

    
//     const [isTotalBeneficiaryChartLoading, setIsTotalBeneficiaryChartLoading] = useState(false);
    
//     const [isGetAllDeliveredCountLoading, setIsGetAllDeliveredCountLoading] = useState(false);
//     const [isResourcesDeliveredChartLoading, setIsResourcesDeliveredChartLoading] = useState(false);

//     const [isCompliancesChartDataLoading, setIsCompliancesChartDataLoading] = useState(false);
//     const [isMarketConnectChartDataLoading, setIsMarketConnectChartDataLoading] = useState(false);
//     const [isExpertConsultationChartDataLoading, setIsExpertConsultationChartDataLoading] = useState(false);
//     const [groupKnowledgeSessionCharDatatLoading, setGroupKnowledgeSessionChartDataLoading] = useState(false);
//     const [blrpPieChartDataLoading, setBlrpPieChartDataLoading] = useState(false)

//     console.log(`${DOWNLOAD_API_URL}/static_live/Reports/${eligibleReportResourceAvailed}`, ">>>download resiurce availed url");
//     console.log(groupknowledgesession, ">>>>>groupknowledgesession all");
//     console.log(groupknowledgeAsOnDate, ">>>groupKnowldege As On date");
//     console.log(expertconsultation, ">>>expertconsultation all data");
//     console.log(expertConsultationAsOnDate, ">>>>expertConsultationAsOnDate ");
//     console.log(marketlinkagesession, ">>>> market connect all data");
//     console.log(marketLinkageSessionAsOnDate, ">>>>marketLinkageSessionAsOnDate");
//     console.log(compliancesession, ">>>>compliancesession all data");
//     console.log(complianceAsOnDate, ">>>>complianceAsOnDate");
//     console.log(blrpsession, ">>>>blrpsession all data");

    
//     console.log(blrpSessionAsOnDate, ">>>>blrpSessionAsOnDate");
    
    
//     return (
//         // <div className={`${isLoading && "set-opacity"}`}>
//         //     {isLoading && <Spinner className="center-screen" />}
//         <div>
//             {/* {isLoading && <Spinner className="center-screen" />} */}
//             <div className='row mt-2 ml-1'>
//                 <div className="esp-dashboard-card1 conv-text-center" style={{ height: '38px', paddingleft: '10px', marginRight: "20px" }}>
//                     <label className="esp-box-header-title">Mobilization: {mobilizationCountData || 0}</label>
//                     {/* <h5 className="esp-count-text">{0}</h5> */}
//                     <div style={{ clear: "both" }}></div>

//                 </div>
//                 {/* <div className="col-12"> */}
//                 {/* <div className='col-2'> */}
//                 {/* <a className="con-cursor-pointer"
//                                 href={`${DOWNLOAD_API_URL}/static_live/Reports/JPMCDashboardData ${getCurrentDate()}.xlsx`} download={`JPMCDashboardData ${getCurrentDate()}.xlsx`}>

//                                 <button
//                             className="lpm-con-btn-filled conv-pr35 conv-pl35">
//                             Download CSV
//                         </button>

//                             </a>     */}

//                 <a className="con-cursor-pointer"
//                     href="https://www.deasra.in/program-dashboard/?download_jpmc_program_data=yes" target='_blank'>

//                     <button
//                         className="lpm-con-btn-filled conv-pr20 conv-pl20" style={{borderRadius:".25rem"}}>
//                         CSV
//                         <img src={downloadIcon} title="Download CSV" alt="" style={{
//                         cursor: "pointer",
//                         width: "20px",
//                         marginLeft:"10px"
//                     }} />
//                     </button>

//                 </a>

//                 {/* <div className='esp-count-text' style={{
//                     border: '1px solid gray',
//                     borderRadius: '2px',
//                     height: 'fit-content',
//                     padding: '5px 28px',
//                     marginLeft: '25px',
//                     marginRight: '10px',
//                     backgroundColor: '#eee'
//                 }}>
//                     Mobilization: <br/>1000
//                 </div> */}


//                 {/* </div> */}

//                 <div className="col-9 ml-2">
//                     <div className="row">
//                         <div className="col-3 spled-container conv-zindex">
//                             <div className="width-100">
//                                 <ReactDatePicker
//                                     dateFormat="dd/MM/yyyy"
//                                     selected={fromDate}
//                                     onChange={(date) => ondatechange("fromDate", date)}
//                                     placeholderText="From Date"
//                                     minDate={new Date("01-01-2024")}
//                                     maxDate={new Date()}
//                                 />
//                             </div>
//                         </div>

//                         <div className="col-3 spled-container conv-zindex">
//                             <div className="width-100">
//                                 <ReactDatePicker
//                                     dateFormat="dd/MM/yyyy"
//                                     selected={toDate}
//                                     onChange={(date) => ondatechange("toDate", date)}
//                                     placeholderText="To Date"
//                                     minDate={new Date("01-01-2024")}
//                                     maxDate={new Date()}
//                                 />
//                             </div>
//                         </div>

//                         <div className="col-6 spled-container">
//                             <div className='row'>
//                                 <div className='col-3 conv-pl10' style={{padding:"0px"}}>
//                                     <Button className="esp-inline-button" style={{
//                                         height: '41px', width:"90%",
//                                     }} onClick={handleSearch} >Search</Button>
//                                 </div>

//                                 <div className='col-3 conv-pl10' style={{padding:"0px"}}>
//                                     <Button className="esp-inline-button" style={{
//                                         height: '41px', width:"90%",
//                                     }} onClick={handleClear} >Clear</Button>
//                                 </div>

//                                 <div className='col-6 conv-pl10' style={{padding:"0px"}}>
//                                 <a className='con-cursor-pointer' href={`${DOWNLOAD_API_URL}/static_live/Reports/${eligibleReportResourceAvailed}`}>
//                                     <button className="lpm-con-btn-filled conv-pr15 conv-pl15" style={{borderRadius:".25rem"}} disabled={!eligibleReportResourceAvailed ? "disabled" : "" }>
//                                         Resources Availed

//                                         <img src={downloadIcon} title="Download Resources Availed" alt="" style={{
//                                         cursor: "pointer",
//                                         width: "20px",
//                                         marginLeft:"10px"
//                                     }} />
//                                     </button>
//                                 </a> 
//                                 </div>
//                             </div>
//                         </div>

//                     </div>
//                 </div>

//                 {/* <div className='col-1'></div> */}

//                 {/* <div className='col d-flex' style={{justifyContent:"flex-start", backgroundColor:"yellow", paddingLeft:"0px"}}>
//                         <a className='con-cursor-pointer' href={`${DOWNLOAD_API_URL}/static_live/Reports/${eligibleReportResourceAvailed}`}>
//                             <button className="lpm-con-btn-filled conv-pr15 conv-pl15" style={{borderRadius:".25rem"}}>
//                                 Resources Availed

//                                 <img src={downloadIcon} title="Download Resources Availed" alt="" style={{
//                                 cursor: "pointer",
//                                 width: "20px",
//                                 marginLeft:"10px"
//                             }} />
//                             </button>
//                         </a>  
//                 </div> */}

//                 {/* </div> */}



//             </div>

//             <div className="row mb-4">

//                 <div className={`col-4 ${isEligibleLoading && "set-opacity"}`}>
//                     {isEligibleLoading && <Spinner className="center" />}
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff",
//                         height: '220px'
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                             <label className="esp-box-header-title mt-2">Eligible</label>

//                         {/* <div className='row esp-box-header-title mt-4'>
//                             <div className="col-4"></div>
//                             <div className="col-4">Mobilization</div>
//                             <div className="col-4">Eligible</div>
//                         </div>
//                         <div className='row esp-count-text mt-2'>
//                             <div className="col-4">Target <br/> <span style={{ color: "#78417C" }}>2000</span></div>
//                             <div className="col-4">As on date <br/> <span style={{ color: "#78417C" }}>{mobilizationCountData || 0}</span></div>
//                             <div className="col-4">As on date <br/>
//                             <span style={{ color: "#78417C" }}>
//                                     {countData > 0 ? (
//                                         <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/Eligible ${getCurrentDate()}.xlsx`} download={`Mobilization ${getCurrentDate()}.xlsx`}>
//                                             {countData}
//                                         </a>
//                                     ) : (
//                                         <span>{countData}</span>
//                                     )}
//                             </span>
//                             </div>/
//                         </div> */}
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
//                             <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>2000</span></h5>
//                             <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
//                                 {countData > 0 ? (
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/Eligible ${getCurrentDate()}.xlsx`} download={`Mobilization ${getCurrentDate()}.xlsx`}>
//                                         {countData}
//                                     </a>
//                                 ) : (
//                                     <span>{countData}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         <div style={{ clear: "both" }}></div>
//                         <div style={{ justifyContent: 'space-around', padding: "35px" }}></div>
//                         <div className='count-text'>
//                             <span style={{ color: 'lightslategray' }}>
//                                 *The eligible entrepreneurs were identified for further interventions                        </span>
//                         </div>
//                     </div>
//                 </div>

//                 <div className={`col-4 ${isGroupKnowledgeSessionLoading && "set-opacity"}`}>
//                     {isGroupKnowledgeSessionLoading && <Spinner className="center" />}
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff"
//                         height: "220px",
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                         <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${groupknowledgesession}`} download={`${groupknowledgesession}`}>
//                             <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Group Knowledge Session</label>
//                         </a>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
//                             <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>1500</span></h5>
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{groupKnowledgeData || 0}</span></h5> */}
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>
//                                 <a className="con-cursor-pointer" style={{ color: "#78417C" }}
//                                     href={`${DOWNLOAD_API_URL}/static_live/Reports/JPMCDashboardData.xlsx`} download="JPMCDashboardData.xlsx">
//                                     {groupKnowledgeData || 0}
//                                 </a>
//                             </span>
//                             </h5> */}
//                             <h5 className="esp-count-text"
//                             //  title='Requested = 10&#10;In Progress = 3&#10;Delivered = 10'
//                             // title={title}

//                             >As on Date <br /> <span style={{ color: "#78417C" }}>
//                                     {groupKnowledgeSessionDelivered > 0 ? (
//                                         <>
//                                             <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${groupknowledgeAsOnDate}`} download={`${groupknowledgeAsOnDate}`}>
//                                                 {/* {groupKnowledgeData} */}
//                                                 {groupKnowledgeSessionDelivered}
//                                             </a>
//                                         </>
//                                     ) : (
//                                         <span>{groupKnowledgeSessionDelivered}</span>
//                                     )}
//                                 </span>
//                             </h5>
//                         </div>
//                         <div style={{ clear: "both" }}></div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Interested <br /> <span style={{ color: "#78417C" }}>{groupKnowledgeSessionRequested}</span></h5>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Attended <br/> <span style={{ color: "#78417C" }}>{groupKnowledgeSessionDelivered}</span></h5> */}
//                         </div>
//                         <div className='count-text'>
//                             <span style={{ color: 'lightslategray' }}>
//                                 *Remaining women entrepreneurs could not attend the session due to various reasons
//                             </span>
//                         </div>
//                     </div>
//                 </div>

//                 <div className={`col-4 ${isExpertConsultationLoading && "set-opacity"}`}>
//                     {isExpertConsultationLoading && <Spinner className="center" />}
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff",
//                         height: '220px'
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                         <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${expertconsultation}`} download={`${expertconsultation}`}>
//                             <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Expert Consultation</label>
//                         </a>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
//                             <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>800</span></h5>
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{expertData || 0}</span></h5> */}
//                             <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
//                                 {expertConsultationDelivered > 0 ? (
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${expertConsultationAsOnDate}`} download={`${expertConsultationAsOnDate}`}>
//                                         {/* {expertData} */}
//                                         {expertConsultationDelivered}
//                                     </a>
//                                 ) : (
//                                     // <span>{expertData}</span>
//                                     <span>{expertConsultationDelivered}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         <div style={{ clear: "both" }}></div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Requested <br /> <span style={{ color: "#78417C" }}>{expertConsultationRequested}</span></h5> */}
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Interested <br /> <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered <br/> <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5> */}
//                         </div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Cancelled: <span style={{ color: "#78417C" }}>{experConsultationCancelled}</span></h5> */}
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>In Progress: <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered: <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5> */}
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div className="row mt-2 mb-4">
//                 <div className={`col-4 ${isMarketConnectLoading && "set-opacity"}`}>
//                     {isMarketConnectLoading && <Spinner className="center" />}
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff",
//                         height: '220px'
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                         <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${marketlinkagesession}`} download={`${marketlinkagesession}`}>
//                             <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Market Connect</label>
//                         </a>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>500</span></h5>
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{marketConnectData || 0}</span></h5> */}
//                             <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
//                                 {marketConnectDelivered > 0 ? (
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${marketLinkageSessionAsOnDate}`} download={`${marketLinkageSessionAsOnDate}`}>
//                                         {/* {marketConnectData} */}
//                                         {marketConnectDelivered}
//                                     </a>
//                                 ) : (
//                                     <span>{marketConnectDelivered}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         <div style={{ clear: "both" }}></div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Interested<br /> <span style={{ color: "#78417C" }}>{marketConnectRequested}</span></h5>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Opportunities Availed<br/> <span style={{ color: "#78417C" }}>{marketConnectDelivered}</span></h5> */}
//                         </div>
//                         <div className='count-text'>
//                             <span style={{ color: 'lightslategray' }}>
//                                 *Remaining women entrepreneurs could not avail the market opportunities due to some reasons
//                             </span>
//                         </div>
//                     </div>
//                 </div>

//                 <div className={`col-4 ${isComplianceLoading && "set-opacity"}`}>
//                     {isComplianceLoading && <Spinner className="center" />}
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff",
//                         height: '220px'
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                         <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${compliancesession}`} download={`${compliancesession}`}>
//                             <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Compliance</label>
//                         </a>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>100</span></h5>
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{complianceData || 0}</span></h5> */}
//                             <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
//                                 {complianceDelivered > 0 ? (
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${complianceAsOnDate}`} download={`${complianceAsOnDate}`}>
//                                         {/* {complianceData} */}
//                                         {complianceDelivered}
//                                     </a>
//                                 ) : (
//                                     <span>{complianceDelivered}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         {/* <div style={{ clear: "both" }}></div> */}
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Requested <br /> <span style={{ color: "#78417C" }}>{complianceRequested}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>In Progress <br /> <span style={{ color: "#78417C" }}>{complianceProgress}</span></h5>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered <br/> <span style={{ color: "#78417C" }}>{complianceDelivered}</span></h5> */}
//                         </div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Cancelled: <span style={{ color: "#78417C" }}>{complianceCancellled}</span></h5> */}
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>In Progress: <span style={{ color: "#78417C" }}>{complianceProgress}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered: <span style={{ color: "#78417C" }}>{complianceDelivered}</span></h5> */}
//                         </div>
//                     </div>
//                 </div>

//                 <div className={`col-4 ${isBlrpLoading && "set-opacity"}`}>
//                     {isBlrpLoading && <Spinner className="center" />}
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff",
//                         height: '220px'
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                         <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${blrpsession}`} download={`${blrpsession}`}>
//                             <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Business Loan Readiness Program</label>
//                         </a>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
//                             <h5 className="esp-count-text">Target <br /><span style={{ color: "#78417C" }}>100</span></h5>
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{blrpData || 0}</span></h5> */}
//                             <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
//                                 {blrpDelivered > 0 ? (
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${blrpSessionAsOnDate}`} download={`${blrpSessionAsOnDate}`}>
//                                         {/* {blrpData} */}
//                                         {blrpDelivered}
//                                     </a>
//                                 ) : (
//                                     <span>{blrpDelivered}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         <div style={{ clear: "both" }}></div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Requested <br /> <span style={{ color: "#78417C" }}>{blrpRequested}</span></h5> */}
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Interested <br /> <span style={{ color: "#78417C" }}>{blrpProgress}</span></h5>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered <br/> <span style={{ color: "#78417C" }}>{blrpDelivered}</span></h5> */}
//                         </div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Cancelled: <span style={{ color: "#78417C" }}>{blrpCancelled}</span></h5> */}
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>In Progress: <span style={{ color: "#78417C" }}>{blrpProgress}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered: <span style={{ color: "#78417C" }}>{blrpDelivered}</span></h5> */}
//                         </div>
//                     </div>
//                 </div>

//             </div>

//             {/* <div className='row mb-3 text-center'>
//                 <div className='col-12'>
//                     <div className='esp-count-text'>
//                         <span style={{color: 'red'}}>
//                         Note: The number indicates both, the services in progress and delivered.
//                         </span>
//                     </div>
//                 </div>
//             </div> */}

//             <div style={{
//                 borderBottom: "2px solid lightgray"
//             }}></div>

//             {/* <div className="row mt-3 mb-2">
//                 <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
//                     <HistogramTotalBeneficiaryChart data={totalBeneChartData} isTotalBeneficiaryChartLoading={isTotalBeneficiaryChartLoading}  />
//                 </div>

//                 <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
//                     <DeliveredResourcePieChart 
//                         data={summaryData} 
//                         totalResourcesDelivered={totalResourcesDelivered} 
//                         entrepreneursCount={complianceDelivered + marketConnectDelivered + expertConsultationDelivered + groupKnowledgeSessionDelivered + blrpDelivered}  
                        
//                         isGetAllDeliveredCountLoading={isGetAllDeliveredCountLoading}
//                         isComplianceLoading={isComplianceLoading}
//                         isMarketConnectLoading={isMarketConnectLoading}
//                         isExpertConsultationLoading={isExpertConsultationLoading}
//                         isGroupKnowledgeSessionLoading={isGroupKnowledgeSessionLoading}
//                         isBlrpLoading={isBlrpLoading}
//                     />
//                 </div>
//             </div> */}

//             {/* <div className="row mt-3 mb-2">
//                 <div className="col-6">
//                     <DataPieChart data={combineData}/> 
//                 </div>

//                 <div className="col-6">
//                     <CustomHistogramChart isLoading={isLoading} data={combineData}/> 
//                 </div>
//             </div> */}

//             <div className="row mt-3 mb-2">
//                 <div className="col-lg-4 col-md-12 col-sm-12 mt-2">
//                     <DeliveredResourcePieChart 
//                         data={summaryData} 
//                         totalResourcesDelivered={totalResourcesDelivered} 
//                         entrepreneursCount={complianceDelivered + marketConnectDelivered + expertConsultationDelivered + groupKnowledgeSessionDelivered + blrpDelivered}  
                        
//                         isGetAllDeliveredCountLoading={isGetAllDeliveredCountLoading}
//                         isComplianceLoading={isComplianceLoading}
//                         isMarketConnectLoading={isMarketConnectLoading}
//                         isExpertConsultationLoading={isExpertConsultationLoading}
//                         isGroupKnowledgeSessionLoading={isGroupKnowledgeSessionLoading}
//                         isBlrpLoading={isBlrpLoading}
//                     />
//                 </div>

//                 <div className="col-lg-4 col-md-12 col-sm-12 mt-2">
//                     <ExpertConsultationPieChart 
//                         data={allFilteredExpertConsultation} 
//                         entrepreneursCount={expertConsultationDelivered} 
//                         allExpertConsultationDeliveredCount={allExpertConsultationDeliveredCount} 

//                         isExpertConsultationChartDataLoading={isExpertConsultationChartDataLoading}
//                         isGetAllDeliveredCountLoading={isGetAllDeliveredCountLoading}
//                         isExpertConsultationLoading={isExpertConsultationLoading}
//                     />
//                 </div>
                
//                 <div className="col-lg-4 col-md-12 col-sm-12 mt-2">
//                     <BlrpPieChart 
//                         data={blrpPieChartData} 
//                         entrepreneursCount={blrpDelivered} 
//                         allBlrpDeliveredCount={allBlrpDeliveredCount} 

//                         isBlrpChartDataLoading={blrpPieChartDataLoading} 
//                         isGetAllDeliveredCountLoading={isGetAllDeliveredCountLoading} 
//                     />
//                 </div>
//             </div>

//             <div className="row mt-3 mb-3">
//                 <div className="col-lg-4 col-md-12 col-sm-12 mt-2">
//                     <MarketLinkagePieChart 
//                         data={filteredMarketLinkage} 
//                         entrepreneursCount={marketConnectDelivered}  
//                         allMarketConnectDeliveredCount={allMarketConnectDeliveredCount} 

//                         isMarketConnectChartDataLoading={isMarketConnectChartDataLoading}
//                         isGetAllDeliveredCountLoading={isGetAllDeliveredCountLoading}  
//                     />
//                     {/* <CustomHistogramChart isLoading={isLoading} data={combineData}/>  */}
//                 </div>


//                 <div className="col-lg-4 col-md-12 col-sm-12 mt-2">
//                     <CompliancePieChart 
//                         data={filteredCompliance} 
//                         entrepreneursCount={complianceDelivered} 
//                         allComplianceDeliveredCount={allComplianceDeliveredCount} 

//                         isCompliancesChartDataLoading={isCompliancesChartDataLoading} 
//                         isGetAllDeliveredCountLoading={isGetAllDeliveredCountLoading} 
//                     />
//                 </div>

//                 <div className="col-lg-4 col-md-12 col-sm-12 mt-2">
//                     {/* <DataPieChart data={combineData}/>  */}
//                     {/* <CompliancePieChart data={filteredCompliance} /> */}
//                     <KnowledgeSessionPieChart 
//                         data={combineData} 
//                         entrepreneursCount={groupKnowledgeSessionDelivered} 
//                         allGroupKnowledgeSessionDeliveredCount={allGroupKnowledgeSessionDeliveredCount} 

//                         groupKnowledgeSessionCharDatatLoading={groupKnowledgeSessionCharDatatLoading}
//                         isGetAllDeliveredCountLoading={isGetAllDeliveredCountLoading}  
//                     />
//                 </div>
//             </div>

//             {
//                 loadMore &&
//                 <>
//                     {/* <div className="row mt-2 mb-2">
//                         <div className="col-md-12">
//                             <JpmcMainTable isLoading={isLoading} data={combineData} />
//                         </div>
//                     </div> */}

//                     {/* <div className="row mt-2 mb-2">
//                         <div className="col-lg-6 col-md-12 col-sm-12">
//                             <AgeWiseJpmcTable isLoading={isLoading} data={ageWiseData} />
//                         </div>

//                         <div className="col-lg-6 col-md-12 col-sm-12">
//                             <IncomeJpmcTable isLoading={isLoading} data={businessIncData} />
//                         </div>
//                     </div> */}

//                     {/* <div className="row mt-2 mb-4">
//                         <div className="col-lg-6 col-md-12 col-sm-12">
//                             <SectorWiseJpmcTable isLoading={isLoading} data={sectorWiseData} />
//                         </div>

//                         <div className="col-lg-6 col-md-12 col-sm-12">
//                             <FamilyIncomeJpmcTable isLoading={isLoading} data={familyIncData} />
//                         </div>
//                     </div> */}

//                     {/* <div className="row mt-2 mb-4">
//                         <div className="col-md-12">
//                             <JpmcExpenseTable isLoading={isLoading} data={jpmcExpsData} />
//                         </div>
//                     </div> */}
//                 </>
//             }

//             {/* {
//                 !loadMore &&
//                 <div className='d-flex justify-content-center mt-2 mb-3'>
//                     <button className="my-services-model-cancel-btn" onClick={() => setLoadMore(true)} >Load More</button>
//                 </div>
//             } */}

//         </div>
//     )
// }

// export default JpmcDashboardContainer



// NEW changes in JPMC cards, all bottom details are commented
// When taking complete file from staging file, make sure to change the payload-
import React, { useEffect, useState } from 'react'
import ReactDatePicker from "react-datepicker";
import { Button } from "../../common/Button/Button";
import JpmcMainTable from './JpmcMainTable';
import AgeWiseJpmcTable from './AgeWiseJpmcTable';
import SectorWiseJpmcTable from './SectorWiseJpmcTable';
import FamilyIncomeJpmcTable from './FamilyIncomeJpmcTable';
import IncomeJpmcTable from './IncomeJpmcTable';
import api from '../../utils/api';
import Spinner from '../../common/Spinner/Spinner';
import DataPieChart from './DataPieChart';
import CustomHistogramChart from './CustomHistogramChart';
import HistogramTotalBeneficiaryChart from './HistogramTotalBeneficiaryChart';
import CompliancePieChart from './CompliancePieChart';
import MarketLinkagePieChart from './MarketLinkagePieChart';
import DeliveredResourcePieChart from './DeliveredResourcePieChart';
import { toast } from 'react-toastify';
import JpmcExpenseTable from './JpmcExpenseTable';
import { DOWNLOAD_API_URL } from '../../utils/constants';
import KnowledgeSessionPieChart from './KnowledgeSessionPieChart';
import { Info } from 'react-feather';
import ExpertConsultationPieChart from './ExpertConsultationPieChart';
import downloadIcon from "../../assets/downloadsvg2.svg"
import BlrpPieChart from './BlrpPieChart';
import DigitalEnablementPieChart from './DigitalEnablementPieChart';



const JpmcDashboardContainer = () => {

    const [fromDate, setfromDate] = useState();
    const [toDate, settoDate] = useState();
    const [ageWiseData, setAgeWiseData] = useState([])
    const [sectorWiseData, setSectorWiseData] = useState([])
    const [familyIncData, setFamilyIncData] = useState([])
    const [businessIncData, setBusinessIncData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [digitalData, setDigitalData] = useState([]);
    const [clearClicked, setClearClicked] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [countData, setCountData] = useState("")
    const [mobilizationCountData, setMobilizationCountData] = useState("")
    const [totalBeneChartData, setTotalBeneChartData] = useState([])
    const [groupKnowledgeData, setGroupKnowliedgeData] = useState()
    const [digitalEnablementData, setDigitalEnablementData] = useState();
    const [expertData, setExpertData] = useState()
    const [marketConnectData, setMarketConnectData] = useState()
    const [complianceData, setComplianceData] = useState()
    const [blrpData, setBlrpData] = useState()
    const [loadMore, setLoadMore] = useState(false)
    const [filteredCompliance, setFilteredCompliance] = useState([])
    const [filteredMarketLinkage, setFilteredMarketLinkage] = useState([])
    const [summaryData, setSummaryData] = useState([])
    const [jpmcExpsData, setJpmcExpsData] = useState([])

    const [complianceReportData, setComplianceReportData] = useState()
    const [groupKnowledgeSessionReportData, setGroupKnowledgeSessionReportData] = useState()
    const [digitalEnablementReportData, setDigitalEnablementReportData] = useState();

    const [complianceRequested, setComplianceRequested] = useState()
    const [complianceProgress, setComplianceProgress] = useState()
    const [complianceDelivered, setComplianceDelivered] = useState(0)
    const [complianceCancellled, setComplianceCancelled] = useState()
    const [allComplianceDeliveredCount, setAllComplianceDeliveredCount] = useState(0)

    const [groupKnowledgeSessionRequested, setGroupKnowledgeSessionRequested] = useState()
    const [digitalEnablementRequested, setDigitalEnablementRequested] = useState();
    const [groupKnowledgeSessionProgress, setGroupKnowledgeSessionProgress] = useState()
    const [groupKnowledgeSessionDelivered, setGroupKnowledgeSessionDelivered] = useState()
    const [digitalEnablementSessionDelivered, setDigitalEnablementSessionDelivered] = useState();
    const [allGroupKnowledgeSessionDeliveredCount, setAllGroupKnowledgeSessionDeliveredCount] = useState(0);
    const [allBlrpDeliveredCount, setAllBlrpDeliveredCount] = useState(0)
    const [allDepDeliveredCount, setAllDepDeliveredCount] = useState(0);
    const [repeatGroupKnowledgeSessionUser, setRepeatGroupKnowledgeSessionUser] = useState(0);

    const [expertConsultationRequested, setExpertConsultationRequested] = useState()
    const [expertConsultationProgress, setExpertConsultationProgress] = useState()
    const [expertConsultationDelivered, setExpertConsultationDelivered] = useState(0)
    const [experConsultationCancelled, setExpertConsultationCancelled] = useState()
    const [allFilteredExpertConsultation, setAllFilteredExpertConsultation] = useState([])
    const [allExpertConsultationDeliveredCount, setAllExpertConsultationDeliveredCount] = useState(0);

    const [marketConnectRequested, setMarketConnectRequested] = useState()
    const [marketConnectProgress, setMarketConnectProgress] = useState()
    const [marketConnectDelivered, setMarketConnectDelivered] = useState()
    const [allMarketConnectDeliveredCount, setAllMarketConnectDeliveredCount] = useState(0)

    const [blrpRequested, setBlrpRequested] = useState()
    const [blrpProgress, setBlrpProgress] = useState()
    const [blrpDelivered, setBlrpDelivered] = useState()
    const [blrpCancelled, setBlrpCancelled] = useState()
    const [depData ,setDepData] = useState();
    const [depRequested, setDepRequested] = useState();
    const [depProgress, setDepProgress] = useState();
    const [depDelivered, setDepDelivered] = useState();
    const [deppCancelled, setDepCancelled] = useState();
    const [isDepLoading, setIsDepLoading] = useState(false);

    const [groupknowledgesession, setgroupknowledgesession] = useState("")
    const [groupknowledgeAsOnDate, setGroupknowledgeAsOnDate] = useState("");

    const [marketlinkagesession, setmarketlinkagesession] = useState([])
    const [marketLinkageSessionAsOnDate, setMarketLinkageSessionAsOnDate] = useState("");

    const [compliancesession, setcompliancesession] = useState([])
    const [complianceAsOnDate, setComplianceAsOnDate] = useState("");

    const [expertconsultation, setexpertconsultation] = useState([])
    const [expertConsultationAsOnDate, setExpertConsultationAsOnDate] = useState("");

    const [blrpsession, setblrpsession] = useState([])
    const [depsession, setDeppsession] = useState([]);
    const [blrpSessionAsOnDate, setBlrpSessionAsOnDate] = useState("")
    const [blrpPieChartData, setBlrpPieChartData] = useState([])
    const [depSessionAsOnDate, seDepSessionAsOnDate] = useState("");

    const [eligibleReportResourceAvailed, setEligibleReportResourceAvailed] = useState("Resource_Availed.xlsx");

    const [totalResourcesDelivered, setTotalResourcesDelivered] = useState(0);

     const [programTypeOptions, setProgramTypeOptions,] = useState([
        {
            value: "JPMC_Programe",
            label: "JPMC Program",
        },
        {
            value: "Anek_Programe",
            label: "SPL Program",
        },
    ]);
    const [selectedProgramType, setSelectedProgramType,] = useState({
            value: "JPMC_Programe",
            label: "JPMC Program",
        });


    useEffect(() => {
        const mobileWidthBreakpoint = 768;

        const displayToastForMobileResolution = () => {
            if (window.innerWidth < mobileWidthBreakpoint) {
                toast("This dashboard is best viewable in a desktop browser.", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
        };

        displayToastForMobileResolution();

        window.addEventListener('resize', displayToastForMobileResolution);

        return () => window.removeEventListener('resize', displayToastForMobileResolution);
    }, []);

    const ondatechange = (key, date) => {
        if (key === "fromDate") {
            setfromDate(date)

        } else if (key === "toDate") {
            settoDate(date)

        }
    };

    const dateAdjusted = (date) => {
        let toDateAdjusted;
        if (date) {
            toDateAdjusted = new Date(date);

            toDateAdjusted = new Date(
                toDateAdjusted.setTime(
                    toDateAdjusted.getTime() + (29.5 * 60 * 60 * 1000 - 1000)
                )
            );
        }
        return toDateAdjusted;
    }

    const dateAdjusted1 = (date) => {
        let toDateAdjusted;
        if (date) {
            toDateAdjusted = new Date(date);

            toDateAdjusted = new Date(
                toDateAdjusted.setTime(
                    toDateAdjusted.getTime() + (5.5 * 60 * 60 * 1000)
                )
            );
        }
        return toDateAdjusted;
    }

    const filterAndCombineData = (data, keyToCompare) => {
        const combinedData = {};

        data.forEach(entry => {
            const key = `${entry[keyToCompare]}_${entry.sResourceDisplayName}`;

            if (combinedData[key]) {
                combinedData[key].sMobile_count += entry.sMobile_count;
            } else {
                combinedData[key] = { ...entry };
            }
        });

        const combinedDataArray = Object.values(combinedData);

        return combinedDataArray;
    };

    // useEffect(() => {
    //     setSummaryData([
    //         ["Expert Consultation", expertConsultationDelivered],
    //         ["Market Connect", marketConnectDelivered],
    //         ["Group Knowledge Session", groupKnowledgeSessionDelivered],
    //         ["BLRP", blrpDelivered],
    //         ["Compliance", complianceDelivered]
    //     ])
    // }, [groupKnowledgeSessionDelivered, complianceDelivered, expertConsultationDelivered, marketConnectDelivered, blrpDelivered])

    const getTableData = () => {
        setIsEligibleLoading(true);
        setIsGroupKnowledgeSessionLoading(true);
        setIsExpertConsultationLoading(true);
        setIsMarketConnectLoading(true);
        setIsComplianceLoading(true);
        setIsBlrpLoading(true);
        setIsDepLoading(true);

        setIsTotalBeneficiaryChartLoading(true);

        setIsGetAllDeliveredCountLoading(true);
        setIsCompliancesChartDataLoading(true);
        setIsMarketConnectChartDataLoading(true);
        setIsExpertConsultationChartDataLoading(true);
        setGroupKnowledgeSessionChartDataLoading(true);
        setDigitalEanblementProgramCharDatatLoading(true);
        setBlrpPieChartDataLoading(true);

        let filterParameters = {}

        if (fromDate) {
            filterParameters.fromDate = dateAdjusted1(fromDate)
        }

        if (toDate) {
            filterParameters.toDate = dateAdjusted(toDate)
        }
        if(selectedProgramType){
            filterParameters.sPrograme_type = selectedProgramType.value;
        }

        console.log("Filter", filterParameters)
        setIsLoading(true)

        let payload = {
            api_key : "r54B?rHXUE7v%$9t",
            // api_key: "82mqEyJnct4kzC8y",

        }

        const { tempMobilizationCount } = api.mobilizationCountApi(payload)
            .then(({ data }) => {
                setMobilizationCountData(data.data.total_count)
            })
            .catch(err => {
                console.log("Error",err);
            })

        const { tempCountData } = api.jpmcCountData(filterParameters)
            .then(({ data }) => {
                console.log("COUNT", data.count)
                setCountData(data.count)
                setIsEligibleLoading(false);
            })

        const { tempTotalBeneficiaryData } = api.totalBeneficiaryChartData(filterParameters)
            .then(({ data }) => {
                console.log("Chart Data", data)
                setTotalBeneChartData(data)
                setIsTotalBeneficiaryChartLoading(false);
            })

        const { tempJpmcExpenseData } = api.jpmcExpenseTableData(filterParameters)
            .then(({ data }) => {
                console.log("Expense Data", data)
                setJpmcExpsData(data.data)
            })

        const { tempComplianceReport } = api.getComplianceReportAPI(filterParameters)
            .then(({ data }) => {
                console.log("Data Report Compliance", data)
                console.log("Data compliance Session Report", data);
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setComplianceAsOnDate(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            })

        const { tempExpertConsultaionReport } = api.getExpertConsultationReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Expert consultation as on date", data)
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setExpertConsultationAsOnDate(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            })

        const { tempMobilizationReport } = api.getMobilizationReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Report Mobilization", data)
            })

        const { tempBlrpReport } = api.getBlrpReport(filterParameters)
            .then(({ data }) => {
                console.log("Data blrp all data", data)
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setBlrpSessionAsOnDate(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            })

        const { tempDepReport } = api.getDepReport(filterParameters)
            .then(({ data }) => {
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                seDepSessionAsOnDate(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            })    
              

        const { tempGroupKnowledgeReport } = api.getGroupKnowledgeReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Group Knowledge Session Report", data);
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setGroupknowledgeAsOnDate(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            })

            const { getDEPSessionReport } = api.getDEPSessionReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Group Knowledge Session Report", data);
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setDeppsession(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            });


        const { tempGroupKnowledgeSessionReport } = api.getGroupKnowledgeSessionReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Group Knowledge Session Report", data);
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setgroupknowledgesession(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            });

        const { tempMarketLinkageSessionReport } = api.getMarketLinkageSessionReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Group Knowledge Session Report", data);
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setmarketlinkagesession(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            });
        const { tempComplianceSessionReport } = api.getComplianceSessionReport(filterParameters)
            .then(({ data }) => {
                console.log("Data compliance sessio Report", data);
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setcompliancesession(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            });
        const { tempExpertConsultationSessionReport } = api.getExpertConsultationSessionReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Group Knowledge Session Report", data);
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setexpertconsultation(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            });
        const { tempblrpSessionReport } = api.getblrpSessionReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Group Knowledge Session Report", data);
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setblrpsession(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            });




        const { tempMarketLinkage } = api.getMarketLinkageReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Report MarketLinkage", data)
                console.log("Data market connect as on date Report", data);
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setMarketLinkageSessionAsOnDate(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            })

        const { tempJpmcAllData } = api.getJpmcAllData(filterParameters)
            .then(({ data }) => {
                console.log("Data Report All", data);
            })
        let complianceCount = 0;
        let complianceCountDelivered = 0;
        let complianceCountRequested = 0;
        let complianceCountProgress = 0;
        let complianceCountCancelled = 0;

        let groupKnowledgeSessionCount = 0;
        let groupKnowledgeSessionCountDelivered = 0;
        let groupKnowledgeSessionCountRequested = 0;
        let groupKnowledgeSessionCountProgress = 0;
        let groupKnowledgeSessionCountCancelled = 0;

        let digitalEnablementSessionCount = 0;
        let digitalEnablementSessionCountRequested = 0
        let digitalEnablementSessionCountDelivered = 0;


        let expertConsultationCount = 0;
        let expertConsultationCountDelivered = 0;
        let expertConsultationCountRequested = 0;
        let expertConsultationCountProgress = 0;
        let expertConsultationCountCancelled = 0;

        let marketConnectCount = 0;
        let marketConnectCountDelivered = 0;
        let marketConnectCountRequested = 0;
        let marketConnectCountProgress = 0;
        let marketConnectCountCancelled = 0;

        let blrpCount = 0;
        let blrpCountDelivered = 0;
        let blrpCountRequested = 0;
        let blrpCountProgress = 0;
        let blrpCountCancelled = 0;

        let depCount = 0;
        let depCountDelivered = 0;
        let depCountRequested = 0;
        let depCountProgress = 0;
        let depCountCancelled = 0;


        let generatedFilePath;



        const { tempComplianceReportData } = api.getComplianceReportDataAPI(filterParameters)
            .then(({ data }) => {
                console.log("ComplianceData", data)
                setComplianceReportData(data.data)

                // // Old Working
                // data.data.forEach(item => {
                //     complianceCount += item.sMobile_count || 0;

                //     if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
                //         complianceCountCancelled += item.sMobile_count || 0;
                //     }

                //     if (item.refCurrentStateSPM === "") {
                //         if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
                //             item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
                //             item.refSRStateLPM === "Quotation Sent") {
                //             complianceCountRequested += item.sMobile_count || 0;
                //         }

                //         if (item.refSRStateLPM === "Payment Received") {
                //             complianceCountProgress += item.sMobile_count || 0;
                //         }
                //     }

                //     if (item.refCurrentStateSPM !== "") {
                //         if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
                //             complianceCountProgress += item.sMobile_count || 0;
                //         }

                //         if (item.refCurrentStateSPM === "Delivered") {
                //             complianceCountDelivered += item.sMobile_count || 0;
                //         }
                //     }
                // })

                // New with changed status for interested
                data.data.forEach(item => {
                    complianceCount += item.sMobile_count || 0;

                    if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
                        complianceCountCancelled += item.sMobile_count || 0;
                    }

                    if (item.refCurrentStateSPM === "") {
                        if (item.refSRStateLPM === "Requested") {
                            complianceCountRequested += item.sMobile_count || 0;
                        }

                        // if (item.refSRStateLPM === "Payment Received") {
                        //     complianceCountProgress += item.sMobile_count || 0;
                        // }
                    }

                    if (item.refCurrentStateSPM !== "") {
                        if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
                            complianceCountProgress += item.sMobile_count || 0;
                        }

                        if (item.refCurrentStateSPM === "Delivered") {
                            complianceCountDelivered += item.sMobile_count || 0;
                        }
                    }
                })

                setComplianceDelivered(complianceCountDelivered)
                setComplianceRequested(complianceCountRequested)
                setComplianceProgress(complianceCountProgress)
                setComplianceCancelled(complianceCountCancelled)
                setComplianceData(complianceCount)
                setIsComplianceLoading(false);
            })

        const { tempGroupKnowledgeReportData } = api.getGroupKnowledgeReportData(filterParameters)
            .then(({ data }) => {
                setGroupKnowledgeSessionReportData(data.data)
                // // old working
                // data.data.forEach(item => {
                //     groupKnowledgeSessionCount += item.sMobile_count || 0;
                //     if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
                //         groupKnowledgeSessionCountRequested += item.sMobile_count || 0;
                //     }

                //     if (item.refCurrentStateSPM === "Delivered") {
                //         groupKnowledgeSessionCountDelivered += item.sMobile_count || 0;
                //     }
                // })

                // new with status changed for interested 
                data.data.forEach(item => {
                    groupKnowledgeSessionCount += item.sMobile_count || 0;

                    if(item.refCurrentStateSPM === "" && item.refSRStateLPM === "Requested"){
                        groupKnowledgeSessionCountRequested += item.sMobile_count || 0;
                    }

                    if (item.refCurrentStateSPM === "Delivered") {
                        groupKnowledgeSessionCountDelivered += item.sMobile_count || 0;
                    }
                })

                setGroupKnowliedgeData(groupKnowledgeSessionCount)
                setGroupKnowledgeSessionRequested(groupKnowledgeSessionCountRequested)
                setGroupKnowledgeSessionDelivered(groupKnowledgeSessionCountDelivered)

                setIsGroupKnowledgeSessionLoading(false)
            })

            
            const { getDigitalEnablementReportData } = api.getDigitalEnablementReportData(filterParameters)
            .then(({ data }) => {
                setDigitalEnablementReportData(data.data)
                // // old working
                // data.data.forEach(item => {
                //     groupKnowledgeSessionCount += item.sMobile_count || 0;
                //     if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
                //         groupKnowledgeSessionCountRequested += item.sMobile_count || 0;
                //     }

                //     if (item.refCurrentStateSPM === "Delivered") {
                //         groupKnowledgeSessionCountDelivered += item.sMobile_count || 0;
                //     }
                // })

                data.data.forEach(item => {
                    depCount += item.sMobile_count || 0;

                    if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
                        depCountCancelled += item.sMobile_count || 0;
                    }

                    if (item.refCurrentStateSPM === "") {
                        if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
                            item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
                            item.refSRStateLPM === "Quotation Sent") {
                            depCountRequested += item.sMobile_count || 0;
                        }

                        // if (item.refSRStateLPM === "Payment Received") {
                        //     blrpCountProgress += item.sMobile_count || 0;
                        // }

                        if(item.refSRStateLPM === "Requested"){
                            depCountProgress += item.sMobile_count || 0;
                        }
                    }

                    if (item.refCurrentStateSPM !== "") {
                        // if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
                        //     blrpCountProgress += item.sMobile_count || 0;
                        // }

                        if (item.refCurrentStateSPM === "Delivered") {
                            depCountDelivered += item.sMobile_count || 0;
                        }
                    }
                })

                // setBlrpData(blrpCount)
                // setBlrpRequested(blrpCountRequested)
                // setBlrpProgress(blrpCountProgress)
                // setBlrpDelivered(blrpCountDelivered) // As On Date
                // setBlrpCancelled(blrpCountCancelled)
                // setIsBlrpLoading(false);
                setDepData(depCount)
                setDepRequested(depCountRequested)
                setDepProgress(depCountProgress)
                // setDepDelivered(depCountDelivered) // As On Date
                setDepDelivered(data.count) // As On Date
                setDepCancelled(depCountCancelled)
                setIsDepLoading(false);

                // new with status changed for interested 
                data.data.forEach(item => {
                    digitalEnablementSessionCount += item.sMobile_count || 0;

                    if(item.refCurrentStateSPM === "" && item.refSRStateLPM === "Requested"){
                        digitalEnablementSessionCountRequested += item.sMobile_count || 0;
                    }

                    if (item.refCurrentStateSPM === "Delivered") {
                        digitalEnablementSessionCountDelivered += item.sMobile_count || 0;
                    }
                })
                console.log('digitalEnablementSessionCount:::',digitalEnablementSessionCount,
                    'digitalEnablementSessionCountRequested:::',digitalEnablementSessionCountRequested,
                    'digitalEnablementSessionCountDelivered:::',digitalEnablementSessionCountDelivered
                )

                setDigitalEnablementData(digitalEnablementSessionCount)
                setDigitalEnablementRequested(digitalEnablementSessionCountRequested)
                setDigitalEnablementSessionDelivered(digitalEnablementSessionCountDelivered)

                setIsDigitalEnablementSessionLoading(false)
            }).catch(err => {
                console.log("Error",err);
                setIsDepLoading(false);
            })

        const { tempExpertConsultaionReportData } = api.getExpertConsultationReportData(filterParameters)
            .then(({ data }) => {

                // //old working
                // data.data.forEach(item => {
                //     expertConsultationCount += item.sMobile_count || 0;

                //     if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
                //         expertConsultationCountCancelled += item.sMobile_count || 0;
                //     }

                //     if (item.refCurrentStateSPM === "") {
                //         if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
                //             item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
                //             item.refSRStateLPM === "Quotation Sent") {
                //             expertConsultationCountRequested += item.sMobile_count || 0;
                //         }

                //         if (item.refSRStateLPM === "Payment Received") {
                //             expertConsultationCountProgress += item.sMobile_count || 0;
                //         }
                //     }

                //     if (item.refCurrentStateSPM !== "") {
                //         if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
                //             expertConsultationCountProgress += item.sMobile_count || 0;
                //         }

                //         if (item.refCurrentStateSPM === "Delivered") {
                //             expertConsultationCountDelivered += item.sMobile_count || 0;
                //         }
                //     }
                // })

                // New with some status changed for Interesed count
                data.data.forEach(item => {
                    expertConsultationCount += item.sMobile_count || 0;

                    if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
                        expertConsultationCountCancelled += item.sMobile_count || 0;
                    }

                    if (item.refCurrentStateSPM === "") {
                        if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
                            item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
                            item.refSRStateLPM === "Quotation Sent") {
                            expertConsultationCountRequested += item.sMobile_count || 0;
                        }
                    }

                    if (item.refCurrentStateSPM !== "") {
                        if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
                            expertConsultationCountProgress += item.sMobile_count || 0;
                        }

                        if (item.refCurrentStateSPM === "Delivered") {
                            expertConsultationCountDelivered += item.sMobile_count || 0;
                        }
                    }
                })

                setExpertData(expertConsultationCount);
                setExpertConsultationRequested(expertConsultationCountRequested)
                setExpertConsultationProgress(expertConsultationCountProgress) // Payment Received k baad ke saare status lene hain
                setExpertConsultationDelivered(expertConsultationCountDelivered)
                setExpertConsultationCancelled(expertConsultationCountCancelled)
                setIsExpertConsultationLoading(false)
            })

        const { tempMarketLinkageData } = api.getMarketLinkageReportData(filterParameters)
            .then(({ data }) => {
                // // old working
                // data.data.forEach(item => {
                //     marketConnectCount += item.sMobile_count || 0;
                //     if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
                //         marketConnectCountRequested += item.sMobile_count || 0;
                //     }

                //     if (item.refCurrentStateSPM === "Delivered") {
                //         marketConnectCountDelivered += item.sMobile_count || 0;
                //     }
                // })

                // New with some status changed for Interested count
                data.data.forEach(item => {
                    marketConnectCount += item.sMobile_count || 0;

                    if (item.refCurrentStateSPM === "" && item.refSRStateLPM === "Requested") {
                        marketConnectCountRequested += item.sMobile_count || 0;
                    }

                    if (item.refCurrentStateSPM === "Delivered") {
                        marketConnectCountDelivered += item.sMobile_count || 0;
                    }
                })

                setMarketConnectData(marketConnectCount);
                setMarketConnectRequested(marketConnectCountRequested)
                setMarketConnectDelivered(marketConnectCountDelivered)
                setIsMarketConnectLoading(false);
            })

        const { tempBlrpReportData } = api.getBlrpReportData(filterParameters)
            .then(({ data }) => {

                // // Old working 
                // data.data.forEach(item => {
                //     blrpCount += item.sMobile_count || 0;

                //     if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
                //         blrpCountCancelled += item.sMobile_count || 0;
                //     }

                //     if (item.refCurrentStateSPM === "") {
                //         if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
                //             item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
                //             item.refSRStateLPM === "Quotation Sent") {
                //             blrpCountRequested += item.sMobile_count || 0;
                //         }

                //         if (item.refSRStateLPM === "Payment Received") {
                //             blrpCountProgress += item.sMobile_count || 0;
                //         }
                //     }

                //     if (item.refCurrentStateSPM !== "") {
                //         if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
                //             blrpCountProgress += item.sMobile_count || 0;
                //         }

                //         if (item.refCurrentStateSPM === "Delivered") {
                //             blrpCountDelivered += item.sMobile_count || 0;
                //         }
                //     }
                // })

                // New with updated status for Interest counts
                data.data.forEach(item => {
                    blrpCount += item.sMobile_count || 0;

                    if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
                        blrpCountCancelled += item.sMobile_count || 0;
                    }

                    if (item.refCurrentStateSPM === "") {
                        if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
                            item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
                            item.refSRStateLPM === "Quotation Sent") {
                            blrpCountRequested += item.sMobile_count || 0;
                        }

                        // if (item.refSRStateLPM === "Payment Received") {
                        //     blrpCountProgress += item.sMobile_count || 0;
                        // }

                        if(item.refSRStateLPM === "Requested"){
                            blrpCountProgress += item.sMobile_count || 0;
                        }
                    }

                    if (item.refCurrentStateSPM !== "") {
                        // if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
                        //     blrpCountProgress += item.sMobile_count || 0;
                        // }

                        if (item.refCurrentStateSPM === "Delivered") {
                            blrpCountDelivered += item.sMobile_count || 0;
                        }
                    }
                })

                setBlrpData(blrpCount)
                setBlrpRequested(blrpCountRequested)
                setBlrpProgress(blrpCountProgress)
                setBlrpDelivered(blrpCountDelivered) // As On Date
                setBlrpCancelled(blrpCountCancelled)
                setIsBlrpLoading(false);

            })


        // const { tempCombineData } = api.mainTableData(filterParameters)
        //     .then(({ data }) => {

        //         // let onlyDeliveredData = data?.filter(obj =>{
        //         //     return obj?.refCurrentStateSPM ===  "Delivered";
        //         // });
        //         // console.log(onlyDeliveredData, ">>>>onlyDeliveredData");
                

        //         // setCombineData(onlyDeliveredData)
        //         // setGroupKnowledgeSessionChartDataLoading(false)

        //         // const ageData = filterAndCombineData(onlyDeliveredData, 'age')
        //         // setAgeWiseData(ageData)

        //         // const sectorData = filterAndCombineData(onlyDeliveredData, 'sBusinessSector')
        //         // setSectorWiseData(sectorData)

        //         // const BusinessIncData = filterAndCombineData(onlyDeliveredData, 'sBusinessTurnover')
        //         // setBusinessIncData(BusinessIncData)

        //         // const FamIncData = filterAndCombineData(onlyDeliveredData, 'sFamilyIncome')
        //         // setFamilyIncData(FamIncData)

        //         // const filteredComplianceData = data.filter((item) => {
        //         //     if (item.sResourceDisplayName === 'Shop Act Intimation' || item.sResourceDisplayName === 'Udyam Registration' || item.sResourceDisplayName === 'FSSAI Licence' || item.sResourceDisplayName === 'Copyright Registration'
        //         //         || item.sResourceDisplayName === 'Trademark Registration' || item.sResourceDisplayName === 'FSSAI Registration' || item.sResourceDisplayName === 'GST Registration') {
        //         //         return item;
        //         //     }
        //         // })

        //         // const filteredMarketLinkageData = data.filter((item) => {
        //         //     if (item.sResourceDisplayName === 'Bulk Buyer' || item.sResourceDisplayName === 'Exhibition' || item.sResourceDisplayName === 'Corporate Linkage' || item.sResourceDisplayName === 'Export' || item.sResourceDisplayName === 'Ecommerce' || item.sResourceDisplayName === 'Shop in Shop') {
        //         //         return item
        //         //     }
        //         // })

        //         // const filteredMarketLinkageData = data.filter((item) => {
        //         //     if (item.sResourceID === 'MKTLINKAGECORPLINKAGE' || item.sResourceID === 'MKTLINKAGEEXHIBITION' || item.sResourceID === 'MKTLINKAGEBULKBUYER' || item.sResourceID === 'MKTLINKAGEEXPORT' || item.sResourceID === 'MKTLINKAGEECOM' || item.sResourceID === 'MKTLINKAGESHOPINSHOP' || item.sResourceID === "DIGITALVISKIT" ) {
        //         //         return item
        //         //     }
        //         // })

        //         // setFilteredCompliance(filteredComplianceData)
        //         // setFilteredMarketLinkage(filteredMarketLinkageData)
        //         // setIsCompliancesChartDataLoading(false);
        //         // setIsMarketConnectChartDataLoading(false);
        //     })

            // // below is dummy expertConsultationApi, in mainTableData API i need sPackage_title key for all expert consultation services
            // // and then i can put below logic in mainTableData api for calculating all expert consultation delivered
            // const {tempXpertConsultationCombineData} = api.dummyExpertConsultationMainTableData(filterParameters)
            //     .then(({data}) =>{
            //         console.log(data?.Response, ">>>>all expert consultation services");
            //         let packageTitles = [
            //             'Expert Clinic_JPMC_Market Linkage',
            //             'Expert Clinic_JPMC_Compliances',
            //             'Expert Clinic_JPMC_Loan Readiness',
            //             'Expert Clinic_JPMC_Rahul Limaye',
            //             'Expert Clinic_JPMC_Dr.Anand Godse',
            //             'Expert Clinic_JPMC_Kavita_Awasthee',
            //             'Expert Clinic_JPMC_Generic',
            //             'Expert Clinic_JPMC_Bhaskar',
            //             'Expert Clinic_JPMC_Bhagyashri Mhatre',
            //             'Expert Clinic_JPMC_Manisha Chandak',
            //             'Expert Clinic_JPMC_Leena Khandekar',
            //             'Expert Clinic_JPMC_Sudhir Gijare',
            //             'Business Loan Sarathi Package',
            //         ];

            //         let allXpert = data.Response.filter((obj) => obj.sResourceID == 'EXPRTCONSULT');

            //         let allDelivered = allXpert.filter(
            //             (obj) => obj.refCurrentStateSPM == 'Delivered'
            //         );

            //         const filteredExpertConsultation = allDelivered.filter(obj => {
            //             if(packageTitles.includes(obj.sPackageOfferTitle)){
            //                 return obj
            //             }
            //         })

            //         setAllFilteredExpertConsultation(filteredExpertConsultation)
            //     }).catch(err=>{
            //         console.log(err,  ">>>Errr");
            //     })

            // below original
            const {tempExpertConsultationAllData} = api.allExpertConsultationServices(filterParameters).then(({data}) =>{
                console.log(data?.Response, ">>>>all expert consultation services");
                // let packageTitles = [
                //     'Expert Clinic_JPMC_Market Linkage',
                //     'Expert Clinic_JPMC_Compliances',
                //     'Expert Clinic_JPMC_Loan Readiness',
                //     'Expert Clinic_JPMC_Rahul Limaye',
                //     'Expert Clinic_JPMC_Dr.Anand Godse',
                //     'Expert Clinic_JPMC_Kavita_Awasthee',
                //     'Expert Clinic_JPMC_Generic',
                //     'Expert Clinic_JPMC_Bhaskar',
                //     'Expert Clinic_JPMC_Bhagyashri Mhatre',
                //     'Expert Clinic_JPMC_Manisha Chandak',
                //     'Expert Clinic_JPMC_Leena Khandekar',
                //     'Expert Clinic_JPMC_Sudhir Gijare',
                //     'Business Loan Sarathi Package'
                // ];

                const filteredDeliveredExpertConsultation = data?.Response.filter(item => {
                    if((item?.sPackageOfferTitle !== "Customized Strategy - Sales, Growth & Social Media Marketing| JPMC| Nov 2025" && item.sResourceID === "EXPRTCONSULT" || item.sResourceID === "LTEXPCOACH") && item.refCurrentStateSPM == "Delivered"){                        
                        return item
                    }
                });

                setAllFilteredExpertConsultation(filteredDeliveredExpertConsultation)
                setIsExpertConsultationChartDataLoading(false);
            }).catch(err =>{
                console.log("ERROR: error in getting all expert consultration services", err);
                setIsExpertConsultationChartDataLoading(false);
            })

            // piechart data for Compliance
            const {tempComplianceAllData} = api.allComplianceServices(filterParameters).then(({data}) => {
                console.log(">>>>allcomplianceapi called");
                
                const filteredComplianceData = data?.Response.filter((item) => {
                    if (item.sResourceDisplayName === 'Shop Act Intimation' || item.sResourceDisplayName === 'Udyam Registration' || item.sResourceDisplayName === 'FSSAI Licence' || item.sResourceDisplayName === 'Copyright Registration'
                        || item.sResourceDisplayName === 'Trademark Registration' || item.sResourceDisplayName === 'FSSAI Registration' || item.sResourceDisplayName === 'GST Registration' || item.sResourceDisplayName === 'Cash Flow Management') {
                        return item;
                    }
                })

                console.log(filteredComplianceData, ">>>filteredComplianceData");
                

                let allComplianceDelivered = filteredComplianceData.filter(item =>{
                    if(item.refCurrentStateSPM == "Delivered"){
                        return item
                    }
                })

                console.log(allComplianceDelivered, ">>>All compliance delivered")

                setFilteredCompliance(allComplianceDelivered);
                setIsCompliancesChartDataLoading(false);
            }).catch(err =>{
                console.log("ERROR: error in getting all compliance services", err);
                setIsCompliancesChartDataLoading(false);
            })

            // piechart data for group knowledge
            const {tempGroupKnowledgeAllData} = api.allGroupKnowledgeServices(filterParameters).then(({data}) => {
                const filteredDeliveredGroupKnowledgeData = data?.Response.filter(item => {
                    if(item.sResourceID === "GRPEXPRTCONSULT" && item.refCurrentStateSPM == "Delivered"){
                        return item
                    }
                });

                setCombineData(filteredDeliveredGroupKnowledgeData);
                setGroupKnowledgeSessionChartDataLoading(false);
            }).catch(err =>{
                console.log("ERROR: error in getting all group knowledge services", err);
                setGroupKnowledgeSessionChartDataLoading(false);
            })

        // const {allDigitalEnablementServices} = api.allDigitalEnablementServices(filterParameters).then(({data}) => {
        const { allDigitalEnablementServices } = api.allDigitalEnablementPieChartServices(filterParameters).then(({ data }) => {

            const filteredDeliveredDigitalEnablementeData = data?.Response.filter(item => {
                if(item.sResourceID === "SOCIALMEDIAMGMT" && item.refCurrentStateSPM == "Delivered" || item.sResourceID === "GOONLINE" && item.refCurrentStateSPM == "Delivered" || item.sResourceID === "WEBDSGNDEV" && item.refCurrentStateSPM == "Delivered"|| item.sResourceID === "MERABILLs" && item.refCurrentStateSPM == "Delivered" || item.sResourceID == "EXPRTCONSULT" && item.refCurrentStateSPM == "Delivered" || item.sResourceID === "VDBRND" && item.refCurrentStateSPM == "Delivered"){                    
                    return item
                }
            });

            setDigitalData(filteredDeliveredDigitalEnablementeData);
            setDigitalEanblementProgramCharDatatLoading(false);
        }).catch(err => {
            console.log("ERROR: error in getting all group knowledge services", err);
            setDigitalEanblementProgramCharDatatLoading(false);
        })

        // allDigitalEnablementServices


            // piechart data for market connect
            const {tempMarketConnectAllData} = api.allMarketConnectServices(filterParameters).then(({data}) => {
                const filteredMarketLinkageData = data?.Response.filter((item) => {
                    if (item.sResourceID === 'MKTLINKAGECORPLINKAGE' || item.sResourceID === 'MKTLINKAGEEXHIBITION' || item.sResourceID === 'MKTLINKAGEBULKBUYER' || item.sResourceID === 'MKTLINKAGEEXPORT' || item.sResourceID === 'MKTLINKAGEECOM' || item.sResourceID === 'MKTLINKAGESHOPINSHOP' || item.sResourceID === "DIGITALVISKIT" ) {
                        return item
                    }
                })

                const allMarketConnectDelivered = filteredMarketLinkageData.filter(item =>{
                    if(item.refCurrentStateSPM == "Delivered"){
                        return item
                    }
                })

                setFilteredMarketLinkage(allMarketConnectDelivered);
                setIsMarketConnectChartDataLoading(false);
            }).catch(err =>{
                console.log("ERROR: error in getting all market connect services", err);
                setIsMarketConnectChartDataLoading(false);
            })

            const {} = api.allBLRPServices(filterParameters).then(({data}) => {
                const filteredBlrpData = data?.Response.filter(item =>{
                    if(item.sResourceID === "FUNDRDYPRPSL" || item.sResourceID === "EXPRTCONSULT"){
                        return item;
                    }
                })

                const allDeliveredBlrp = filteredBlrpData?.filter(item => {
                    if(item.refCurrentStateSPM === "Delivered"){
                        return item
                    }
                })

                // const dummyAllDeliveredBlrp = [
                //     {
                //         "dtCreated": "2025-02-14T10:46:23",
                //         "nResourceInstanceId": 225537,
                //         "sMobile": "9923810825",
                //         "sResourceID": "EXPRTCONSULT",
                //         "ExpertName": "Xpert Cliniq",
                //         "sResourceDisplayName": "toursandtravels",
                //         "sBusinessSector": 21,
                //         "age": "Upto 5 lakhs",
                //         "sFamilyIncome": "Upto 5 lakhs",
                //         "sBusinessTurnover": "Requested",
                //         "refSRStateLPM": "Delivered",
                //         "refCurrentStateSPM": "Delivered"
                //     },
                //     {
                //         "dtCreated": "2025-02-14T10:57:38",
                //         "nResourceInstanceId": 225540,
                //         "sMobile": "9923810825",
                //         "sResourceID": "EXPRTCONSULT",
                //         "ExpertName": "Xpert Cliniq",
                //         "sResourceDisplayName": "toursandtravels",
                //         "sBusinessSector": 21,
                //         "age": "Upto 5 lakhs",
                //         "sFamilyIncome": "Upto 5 lakhs",
                //         "sBusinessTurnover": "Requested",
                //         "refSRStateLPM": "Delivered",
                //         "refCurrentStateSPM": "Delivered"
                //     }
                // ]

                setBlrpPieChartData(allDeliveredBlrp)
                setBlrpPieChartDataLoading(false);
                console.log(allDeliveredBlrp, ">>>allDeliveredBlrp")
                console.log(filteredBlrpData, ">>>filteredBlrpData")
            }).catch(err=> {
                console.error("Error getting blrp piechart")
                setBlrpPieChartDataLoading(false);
            })


        const {tempAllJPMCdeliveredCount} = api.allJpmcDeliveredCounts(filterParameters).then(({data}) =>{
            console.log(data, ">>>all jpmc delivered counts");

            const {Compliances_count, ExpertConsultations_count, MarketOpportunities_count, KnowledgeSessions_count, Digital_count, LoanReadiness_count}= data;            setAllComplianceDeliveredCount(Compliances_count);
            setAllExpertConsultationDeliveredCount(ExpertConsultations_count)
            setAllMarketConnectDeliveredCount(MarketOpportunities_count)
            setAllGroupKnowledgeSessionDeliveredCount(KnowledgeSessions_count)
            setAllBlrpDeliveredCount(LoanReadiness_count)
            setAllDepDeliveredCount(Digital_count)

            const totalResourceCount = Compliances_count + ExpertConsultations_count + MarketOpportunities_count + KnowledgeSessions_count + LoanReadiness_count;

            let summaryData = [
                ["Expert Consultation", ExpertConsultations_count],
                ["Market Connect", MarketOpportunities_count],
                ["Group Knowledge Session", KnowledgeSessions_count],
                ["Compliance", Compliances_count],
                ["Business Loan Readiness", LoanReadiness_count]
            ]
            setSummaryData(summaryData)

            setTotalResourcesDelivered(totalResourceCount)
            setIsGetAllDeliveredCountLoading(false);
        }).catch(err =>{
            console.log("Err geting delivered counts", err); 
        })

        const {tempEligibleReportResourceAvailed} = api.eligibleReportResourceAvailed(filterParameters).then(({data}) =>{
            console.log(data, ">>>>eligibleReportResourceAvailed data");
            let downloadUrl = data?.generated_file;
            let downloadUrlSplit = downloadUrl?.split("/");
            let fileName = downloadUrlSplit[downloadUrlSplit?.length - 1];
            console.log(fileName, ">>>>eligibleReportResourceAvailed file name");
            // setEligibleReportResourceAvailed(`/${fileName}`)
        }).catch(err =>{
            console.log("ERROR: error getting eligible resource availed data", err);
            
        })

        const {tempGroupKnowledgeSessionRepeatUserCount} = api.uniqueRepeatUserGroupKnowledgeSession().then(({data}) => {
            console.log(data, ">>>>>uniqueRepeatUserGroupKnowledgeSession")
            setRepeatGroupKnowledgeSessionUser(data["KnowledgeSessions_Unique_count"])
        }).catch(err => {
            console.error(err)
        })


    }


    useEffect(() => {
        getTableData()
    }, [])

    const handleSearch = () => {
        // setAgeWiseData([])
        // setSectorWiseData([])
        // setBusinessIncData([])
        // setFamilyIncData([])
        // setCombineData([])
        // setTotalBeneChartData([])
        getTableData()
        // setJpmcExpsData([])
    }

    const handleClear = () => {
        setfromDate()
        settoDate()
        setAgeWiseData([])
        setSectorWiseData([])
        setBusinessIncData([])
        setFamilyIncData([])
        setCombineData([])
        setTotalBeneChartData([])
        setJpmcExpsData([])
        setClearClicked(true);
    }


    useEffect(() => {
        if (clearClicked) {
            getTableData();
            setClearClicked(false);
        }
    }, [clearClicked]);

    function getCurrentDate() {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = months[today.getMonth()];
        const year = today.getFullYear();
        return `${day}${month}${year}`;
    }

    const currentDate = getCurrentDate();
    // const title = `Interested = ${groupKnowledgeSessionRequested}&#10;Attended = ${groupKnowledgeSessionDelivered}`;
    const title = "Interested:" + groupKnowledgeSessionRequested + "\n" + "Attended:" + groupKnowledgeSessionDelivered


    // below all loaders states
    const [isEligibleLoading, setIsEligibleLoading] = useState(false);
    const [isGroupKnowledgeSessionLoading, setIsGroupKnowledgeSessionLoading] = useState(false);
    const [isDigitalEnablementSessionLoading, setIsDigitalEnablementSessionLoading] = useState(false);
    const [isExpertConsultationLoading, setIsExpertConsultationLoading] = useState(false);
    const [isMarketConnectLoading, setIsMarketConnectLoading] = useState(false);
    const [isComplianceLoading, setIsComplianceLoading] = useState(false);
    const [isBlrpLoading, setIsBlrpLoading] = useState(false);

    
    const [isTotalBeneficiaryChartLoading, setIsTotalBeneficiaryChartLoading] = useState(false);
    
    const [isGetAllDeliveredCountLoading, setIsGetAllDeliveredCountLoading] = useState(false);
    const [isResourcesDeliveredChartLoading, setIsResourcesDeliveredChartLoading] = useState(false);

    const [isCompliancesChartDataLoading, setIsCompliancesChartDataLoading] = useState(false);
    const [isMarketConnectChartDataLoading, setIsMarketConnectChartDataLoading] = useState(false);
    const [isExpertConsultationChartDataLoading, setIsExpertConsultationChartDataLoading] = useState(false);
    const [groupKnowledgeSessionCharDatatLoading, setGroupKnowledgeSessionChartDataLoading] = useState(false);
    const [digitalEanblementProgramCharDatatLoading, setDigitalEanblementProgramCharDatatLoading] = useState(false)
    const [blrpPieChartDataLoading, setBlrpPieChartDataLoading] = useState(false)

    console.log(`${DOWNLOAD_API_URL}/static_live/Reports/${eligibleReportResourceAvailed}`, ">>>download resiurce availed url");
    console.log(groupknowledgesession, ">>>>>groupknowledgesession all");
    console.log(groupknowledgeAsOnDate, ">>>groupKnowldege As On date");
    console.log(expertconsultation, ">>>expertconsultation all data");
    console.log(expertConsultationAsOnDate, ">>>>expertConsultationAsOnDate ");
    console.log(marketlinkagesession, ">>>> market connect all data");
    console.log(marketLinkageSessionAsOnDate, ">>>>marketLinkageSessionAsOnDate");
    console.log(compliancesession, ">>>>compliancesession all data");
    console.log(complianceAsOnDate, ">>>>complianceAsOnDate");
    console.log(blrpsession, ">>>>blrpsession all data");

    
    console.log(blrpSessionAsOnDate, ">>>>blrpSessionAsOnDate");
    
    
    return (
        // <div className={`${isLoading && "set-opacity"}`}>
        //     {isLoading && <Spinner className="center-screen" />}
        <div>
            {/* {isLoading && <Spinner className="center-screen" />} */}
            <div className='row mt-2 ml-1'>
                <div className="esp-dashboard-card1 conv-text-center" style={{ height: '38px', paddingleft: '10px', marginRight: "10px" }}>
                    {/* <label className="esp-box-header-title">Mobilization: {mobilizationCountData || 0}</label> */}
                    <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }}
                    href="https://www.deasra.in/program-dashboard/?download_jpmc_program_data=yes" target='_blank'>
                    <label className="esp-box-header-title-jpmc hover-underline">Mobilization: {mobilizationCountData || 0}</label>
                    </a>

                    {/* <h5 className="esp-count-text">{0}</h5> */}
                    <div style={{ clear: "both" }}></div>

                </div>
                <div className="esp-dashboard-card1 conv-text-center" style={{ height: '38px', paddingleft: '10px', marginRight: "10px" }}>

                <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/Eligible ${getCurrentDate()}.xlsx`} download={`Eligible ${getCurrentDate()}.xlsx`}>
                            <label className="esp-box-header-title-jpmc hover-underline" style={{ cursor: "pointer" }}>Eligible:
                            {countData > 0 ? (
                                    <a className="con-cursor-pointer" style={{ color: "#000000" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/Eligible ${getCurrentDate()}.xlsx`} download={`Eligible ${getCurrentDate()}.xlsx`}>
                                        {" "}{countData ? countData : 0}
                                    </a>
                                ) : (
                                    <span>{" "}{countData ? countData : 0}</span>
                                )}
                            </label>
                        </a>
                       
                                    </div>

                {/* <div className="col-12"> */}
                {/* <div className='col-2'> */}
                {/* <a className="con-cursor-pointer"
                                href={`${DOWNLOAD_API_URL}/static_live/Reports/JPMCDashboardData ${getCurrentDate()}.xlsx`} download={`JPMCDashboardData ${getCurrentDate()}.xlsx`}>

                                <button
                            className="lpm-con-btn-filled conv-pr35 conv-pl35">
                            Download CSV
                        </button>

                            </a>     */}

                {/* <a className="con-cursor-pointer"
                    href="https://www.deasra.in/program-dashboard/?download_jpmc_program_data=yes" target='_blank'>

                    <button
                        className="lpm-con-btn-filled conv-pr20 conv-pl20" style={{borderRadius:".25rem"}}>
                        CSV
                        <img src={downloadIcon} title="Download CSV" alt="" style={{
                        cursor: "pointer",
                        width: "20px",
                        marginLeft:"10px"
                    }} />
                    </button>

                </a> */}

                {/* <div className='esp-count-text' style={{
                    border: '1px solid gray',
                    borderRadius: '2px',
                    height: 'fit-content',
                    padding: '5px 28px',
                    marginLeft: '25px',
                    marginRight: '10px',
                    backgroundColor: '#eee'
                }}>
                    Mobilization: <br/>1000
                </div> */}


                {/* </div> */}

                <div className="col-8">
                    <div className="row">
                        <div className="col-3 spled-container conv-zindex">
                            <div className="width-100">
                                <ReactDatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={fromDate}
                                    onChange={(date) => ondatechange("fromDate", date)}
                                    placeholderText="From Date"
                                    minDate={new Date("01-01-2024")}
                                    maxDate={new Date()}
                                />
                            </div>
                        </div>

                        <div className="col-3 spled-container conv-zindex">
                            <div className="width-100">
                                <ReactDatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={toDate}
                                    onChange={(date) => ondatechange("toDate", date)}
                                    placeholderText="To Date"
                                    minDate={new Date("01-01-2024")}
                                    maxDate={new Date()}
                                />
                            </div>
                        </div>

                        <div className="col-6 spled-container">
                            <div className='row'>
                                <div className='col-3 conv-pl5' style={{padding:"0px"}}>
                                    <Button className="esp-inline-button" style={{
                                        height: '41px', width:"85%",
                                    }} onClick={handleSearch} >Search</Button>
                                </div>

                                <div className='col-3 conv-pl5' style={{padding:"0px"}}>
                                    <Button className="esp-inline-button" style={{
                                        height: '41px', width:"85%",
                                    }} onClick={handleClear} >Clear</Button>
                                </div>

                                <div className='col-6 conv-pl0' style={{padding:"0px"}}>
                                <a className='con-cursor-pointer' href={`${DOWNLOAD_API_URL}/static_live/Reports/${eligibleReportResourceAvailed}`}>
                                <button
          className="lpm-con-btn-filled conv-pr5 conv-pl5 w-100"
          style={{ borderRadius: ".25rem", maxHeight: '41px', fontWeight: '550' }}
          disabled={!eligibleReportResourceAvailed}
        >
          Resources Availed
          <img
            src={downloadIcon}
            title="Download Resources Availed"
            alt=""
            style={{ cursor: "pointer", width: "15px", marginLeft: "5px" }}
          />
        </button>
                                </a> 
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {/* <div className='col-1'></div> */}

                {/* <div className='col d-flex' style={{justifyContent:"flex-start", backgroundColor:"yellow", paddingLeft:"0px"}}>
                        <a className='con-cursor-pointer' href={`${DOWNLOAD_API_URL}/static_live/Reports/${eligibleReportResourceAvailed}`}>
                            <button className="lpm-con-btn-filled conv-pr15 conv-pl15" style={{borderRadius:".25rem"}}>
                                Resources Availed

                                <img src={downloadIcon} title="Download Resources Availed" alt="" style={{
                                cursor: "pointer",
                                width: "20px",
                                marginLeft:"10px"
                            }} />
                            </button>
                        </a>  
                </div> */}

                {/* </div> */}



            </div>

            <div className="row mb-4">

                {/* <div className={`col-4 ${isEligibleLoading && "set-opacity"}`}>
                    {isEligibleLoading && <Spinner className="center" />}
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                            <label className="esp-box-header-title mt-2">Eligible</label>

                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
                            <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>2000</span></h5>
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {countData > 0 ? (
                                    <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/Eligible ${getCurrentDate()}.xlsx`} download={`Mobilization ${getCurrentDate()}.xlsx`}>
                                        {countData}
                                    </a>
                                ) : (
                                    <span>{countData}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div style={{ justifyContent: 'space-around', padding: "35px" }}></div>
                        <div className='count-text'>
                            <span style={{ color: 'lightslategray' }}>
                                *The eligible entrepreneurs were identified for further interventions                        </span>
                        </div>
                    </div>
                </div> */}

                {/* <div className={`col-4 ${isEligibleLoading && "set-opacity"}`}>
                    {isEligibleLoading && <Spinner className="center" />}
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff"
                        height: "220px",
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }}>
                            <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Eligible</label>
                        </a>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
                            <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>2000</span></h5>
                            <h5 className="esp-count-text"
                            >As on Date <br /> <span style={{ color: "#78417C" }}>
                                    {countData > 0 ? (
                                    <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/Eligible ${getCurrentDate()}.xlsx`} download={`Mobilization ${getCurrentDate()}.xlsx`}>
                                        {countData}
                                    </a>
                                ) : (
                                    <span>{countData}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}> */}
                                {/* Interested <br /> <span style={{ color: "#78417C" }}>{groupKnowledgeSessionRequested}</span>' */}
                             {/* </h5>
                        </div>
                        <div className='count-text'>
                            <span style={{ color: 'lightslategray', fontSize:"10px" }}>
                                *The eligible entrepreneurs were identified for further interventions  
                            </span>
                        </div>
                    </div>
                </div> */}

                <div className={`col-4 ${isGroupKnowledgeSessionLoading && "set-opacity"}`}>
                    {isGroupKnowledgeSessionLoading && <Spinner className="center" />}
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff"
                        height: "220px",
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${groupknowledgesession}`} download={`${groupknowledgesession}`}>
                            <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Group Knowledge Session</label>
                        </a>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '10px' }}>
                            <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>1500</span></h5>
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{groupKnowledgeData || 0}</span></h5> */}
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>
                                <a className="con-cursor-pointer" style={{ color: "#78417C" }}
                                    href={`${DOWNLOAD_API_URL}/static_live/Reports/JPMCDashboardData.xlsx`} download="JPMCDashboardData.xlsx">
                                    {groupKnowledgeData || 0}
                                </a>
                            </span>
                            </h5> */}
                            <h5 className="esp-count-text"
                            //  title='Requested = 10&#10;In Progress = 3&#10;Delivered = 10'
                            // title={title}

                            >As on Date <br /> <span style={{ color: "#78417C" }}>
                                    {groupKnowledgeSessionDelivered > 0 ? (
                                        <>
                                            <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${groupknowledgeAsOnDate}`} download={`${groupknowledgeAsOnDate}`}>
                                                {/* {groupKnowledgeData} */}
                                                {groupKnowledgeSessionDelivered}
                                            </a>
                                        </>
                                    ) : (
                                        <span>{groupKnowledgeSessionDelivered}</span>
                                    )}
                                </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>
                                {/* Interested <br /> <span style={{ color: "#78417C" }}>{groupKnowledgeSessionRequested}</span>' */}
                             </h5>
                        </div>
                        <div className='count-text'>
                            <span style={{ color: 'lightslategray', display:"none" }}>
                                *Remaining women entrepreneurs could not attend the session due to various reasons
                            </span>
                        </div>
                    </div>
                </div>

                <div className={`col-4 ${isExpertConsultationLoading && "set-opacity"}`}>
                    {isExpertConsultationLoading && <Spinner className="center" />}
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${expertconsultation}`} download={`${expertconsultation}`}>
                            <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Expert Consultation</label>
                        </a>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
                            <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>900</span></h5>
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{expertData || 0}</span></h5> */}
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {expertConsultationDelivered > 0 ? (
                                    <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${expertConsultationAsOnDate}`} download={`${expertConsultationAsOnDate}`}>
                                        {/* {expertData} */}
                                        {expertConsultationDelivered}
                                    </a>
                                ) : (
                                    // <span>{expertData}</span>
                                    <span>{expertConsultationDelivered}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Requested <br /> <span style={{ color: "#78417C" }}>{expertConsultationRequested}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Interested <br /> <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered <br/> <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5> */}
                        </div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Cancelled: <span style={{ color: "#78417C" }}>{experConsultationCancelled}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress: <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered: <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5> */}
                        </div>
                    </div>
                </div>
                <div className={`col-4 ${isMarketConnectLoading && "set-opacity"}`}>
                    {isMarketConnectLoading && <Spinner className="center" />}
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${marketlinkagesession}`} download={`${marketlinkagesession}`}>
                            <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Market Connect</label>
                        </a>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>700</span></h5>
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{marketConnectData || 0}</span></h5> */}
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {marketConnectDelivered > 0 ? (
                                    <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${marketLinkageSessionAsOnDate}`} download={`${marketLinkageSessionAsOnDate}`}>
                                        {/* {marketConnectData} */}
                                        {marketConnectDelivered}
                                    </a>
                                ) : (
                                    <span>{marketConnectDelivered}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Interested<br /> <span style={{ color: "#78417C" }}>{marketConnectRequested}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Opportunities Availed<br/> <span style={{ color: "#78417C" }}>{marketConnectDelivered}</span></h5> */}
                        </div>
                        <div className='count-text'>
                            <span style={{ color: 'lightslategray', display:"none" }}>
                                *Remaining women entrepreneurs could not avail the market opportunities due to some reasons
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-2 mb-4">
                

                <div className={`col-4 ${isComplianceLoading && "set-opacity"}`}>
                    {isComplianceLoading && <Spinner className="center" />}
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${compliancesession}`} download={`${compliancesession}`}>
                            <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Compliance</label>
                        </a>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>200</span></h5>
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{complianceData || 0}</span></h5> */}
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {complianceDelivered > 0 ? (
                                    <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${complianceAsOnDate}`} download={`${complianceAsOnDate}`}>
                                        {/* {complianceData} */}
                                        {complianceDelivered}
                                    </a>
                                ) : (
                                    <span>{complianceDelivered}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        {/* <div style={{ clear: "both" }}></div> */}
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Requested <br /> <span style={{ color: "#78417C" }}>{complianceRequested}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress <br /> <span style={{ color: "#78417C" }}>{complianceProgress}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered <br/> <span style={{ color: "#78417C" }}>{complianceDelivered}</span></h5> */}
                        </div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Cancelled: <span style={{ color: "#78417C" }}>{complianceCancellled}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress: <span style={{ color: "#78417C" }}>{complianceProgress}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered: <span style={{ color: "#78417C" }}>{complianceDelivered}</span></h5> */}
                        </div>
                    </div>
                </div>

                <div className={`col-4 ${isBlrpLoading && "set-opacity"}`}>
                    {isBlrpLoading && <Spinner className="center" />}
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${blrpsession}`} download={`${blrpsession}`}>
                            <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Business Loan Readiness Program</label>
                        </a>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
                            <h5 className="esp-count-text">Target <br /><span style={{ color: "#78417C" }}>100</span></h5>
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{blrpData || 0}</span></h5> */}
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {blrpDelivered > 0 ? (
                                    <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${blrpSessionAsOnDate}`} download={`${blrpSessionAsOnDate}`}>
                                        {/* {blrpData} */}
                                        {blrpDelivered}
                                    </a>
                                ) : (
                                    <span>{blrpDelivered}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Requested <br /> <span style={{ color: "#78417C" }}>{blrpRequested}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Interested <br /> <span style={{ color: "#78417C" }}>{blrpProgress}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered <br/> <span style={{ color: "#78417C" }}>{blrpDelivered}</span></h5> */}
                        </div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Cancelled: <span style={{ color: "#78417C" }}>{blrpCancelled}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress: <span style={{ color: "#78417C" }}>{blrpProgress}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered: <span style={{ color: "#78417C" }}>{blrpDelivered}</span></h5> */}
                        </div>
                    </div>
                </div>
                <div className={`col-4 ${isDepLoading && "set-opacity"}`}>
                    {isDepLoading && <Spinner className="center" />}
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${depsession}`} download={`${depsession}`}>
                            <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Digital Enablement Solution</label>
                        </a>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
                            <h5 className="esp-count-text">Target <br /><span style={{ color: "#78417C" }}>250</span></h5>
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{blrpData || 0}</span></h5> */}
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {depDelivered > 0 ? (
                                    <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${depSessionAsOnDate}`} download={`${depSessionAsOnDate}`}>
                                        {/* {blrpData} */}
                                        {depDelivered ? depDelivered : 0}
                                    </a>
                                ) : (
                                    <span>{depDelivered ? depDelivered : 0}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Requested <br /> <span style={{ color: "#78417C" }}>{blrpRequested}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Interested <br /> <span style={{ color: "#78417C" }}>{blrpProgress}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered <br/> <span style={{ color: "#78417C" }}>{blrpDelivered}</span></h5> */}
                        </div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Cancelled: <span style={{ color: "#78417C" }}>{blrpCancelled}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress: <span style={{ color: "#78417C" }}>{blrpProgress}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered: <span style={{ color: "#78417C" }}>{blrpDelivered}</span></h5> */}
                        </div>
                    </div>
                </div>


            </div>

            {/* <div className='row mb-3 text-center'>
                <div className='col-12'>
                    <div className='esp-count-text'>
                        <span style={{color: 'red'}}>
                        Note: The number indicates both, the services in progress and delivered.
                        </span>
                    </div>
                </div>
            </div> */}

            <div style={{
                borderBottom: "2px solid lightgray"
            }}></div>

            {/* <div className="row mt-3 mb-2">
                <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
                    <HistogramTotalBeneficiaryChart data={totalBeneChartData} isTotalBeneficiaryChartLoading={isTotalBeneficiaryChartLoading}  />
                </div>

                <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
                    <DeliveredResourcePieChart 
                        data={summaryData} 
                        totalResourcesDelivered={totalResourcesDelivered} 
                        entrepreneursCount={complianceDelivered + marketConnectDelivered + expertConsultationDelivered + groupKnowledgeSessionDelivered + blrpDelivered}  
                        
                        isGetAllDeliveredCountLoading={isGetAllDeliveredCountLoading}
                        isComplianceLoading={isComplianceLoading}
                        isMarketConnectLoading={isMarketConnectLoading}
                        isExpertConsultationLoading={isExpertConsultationLoading}
                        isGroupKnowledgeSessionLoading={isGroupKnowledgeSessionLoading}
                        isBlrpLoading={isBlrpLoading}
                    />
                </div>
            </div> */}

            {/* <div className="row mt-3 mb-2">
                <div className="col-6">
                    <DataPieChart data={combineData}/> 
                </div>

                <div className="col-6">
                    <CustomHistogramChart isLoading={isLoading} data={combineData}/> 
                </div>
            </div> */}

            <div className="row mt-3 mb-2">
                <div className="col-lg-4 col-md-12 col-sm-12 mt-2">
                    <DeliveredResourcePieChart 
                        data={summaryData} 
                        totalResourcesDelivered={totalResourcesDelivered} 
                        entrepreneursCount={complianceDelivered + marketConnectDelivered + expertConsultationDelivered + groupKnowledgeSessionDelivered + blrpDelivered}  
                        
                        isGetAllDeliveredCountLoading={isGetAllDeliveredCountLoading}
                        isComplianceLoading={isComplianceLoading}
                        isMarketConnectLoading={isMarketConnectLoading}
                        isExpertConsultationLoading={isExpertConsultationLoading}
                        isGroupKnowledgeSessionLoading={isGroupKnowledgeSessionLoading}
                        isBlrpLoading={isBlrpLoading}
                    />
                </div>

                <div className="col-lg-4 col-md-12 col-sm-12 mt-2">
                    <ExpertConsultationPieChart 
                        data={allFilteredExpertConsultation} 
                        entrepreneursCount={expertConsultationDelivered} 
                        allExpertConsultationDeliveredCount={allExpertConsultationDeliveredCount} 

                        isExpertConsultationChartDataLoading={isExpertConsultationChartDataLoading}
                        isGetAllDeliveredCountLoading={isGetAllDeliveredCountLoading}
                        isExpertConsultationLoading={isExpertConsultationLoading}
                    />
                </div>

                <div className="col-lg-4 col-md-12 col-sm-12 mt-2">
                    <BlrpPieChart 
                        data={blrpPieChartData} 
                        entrepreneursCount={blrpDelivered} 
                        allBlrpDeliveredCount={allBlrpDeliveredCount} 

                        isBlrpChartDataLoading={blrpPieChartDataLoading} 
                        isGetAllDeliveredCountLoading={isGetAllDeliveredCountLoading} 
                    />
                </div>
            </div>

            <div className="row mt-3 mb-3">
                <div className="col-lg-4 col-md-12 col-sm-12 mt-2">
                    <MarketLinkagePieChart 
                        data={filteredMarketLinkage} 
                        entrepreneursCount={marketConnectDelivered}  
                        allMarketConnectDeliveredCount={allMarketConnectDeliveredCount} 

                        isMarketConnectChartDataLoading={isMarketConnectChartDataLoading}
                        isGetAllDeliveredCountLoading={isGetAllDeliveredCountLoading}  
                    />
                    {/* <CustomHistogramChart isLoading={isLoading} data={combineData}/>  */}
                </div>


                <div className="col-lg-4 col-md-12 col-sm-12 mt-2">
                    <CompliancePieChart 
                        data={filteredCompliance} 
                        entrepreneursCount={complianceDelivered} 
                        allComplianceDeliveredCount={allComplianceDeliveredCount} 

                        isCompliancesChartDataLoading={isCompliancesChartDataLoading} 
                        isGetAllDeliveredCountLoading={isGetAllDeliveredCountLoading} 
                    />
                </div>

                <div className="col-lg-4 col-md-12 col-sm-12 mt-2">
                    {/* <DataPieChart data={combineData}/>  */}
                    {/* <CompliancePieChart data={filteredCompliance} /> */}
                    <KnowledgeSessionPieChart 
                        data={combineData} 
                        entrepreneursCount={groupKnowledgeSessionDelivered} 
                        allGroupKnowledgeSessionDeliveredCount={allGroupKnowledgeSessionDeliveredCount} 
                        repeatGroupKnowledgeSessionUser={repeatGroupKnowledgeSessionUser}

                        groupKnowledgeSessionCharDatatLoading={groupKnowledgeSessionCharDatatLoading}
                        isGetAllDeliveredCountLoading={isGetAllDeliveredCountLoading}  
                    />
                </div>
            </div>
             <div className="row mt-3 mb-3">
               

             <div className="col-lg-4 col-md-12 col-sm-12 mt-2">
                 {/* <DataPieChart data={combineData}/>  */}
                 {/* <CompliancePieChart data={filteredCompliance} /> */}
                 <DigitalEnablementPieChart 
                     data={digitalData}
                     entrepreneursCount={digitalEnablementSessionDelivered}
                     allDepDeliveredCount={allDepDeliveredCount} 
                     repeatGroupKnowledgeSessionUser={repeatGroupKnowledgeSessionUser}

                     digitalEanblementProgramCharDatatLoading={digitalEanblementProgramCharDatatLoading}
                     isGetAllDeliveredCountLoading={digitalEanblementProgramCharDatatLoading}  
                 />
             </div>
         </div>


            {
                loadMore &&
                <>
                    {/* <div className="row mt-2 mb-2">
                        <div className="col-md-12">
                            <JpmcMainTable isLoading={isLoading} data={combineData} />
                        </div>
                    </div> */}

                    {/* <div className="row mt-2 mb-2">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <AgeWiseJpmcTable isLoading={isLoading} data={ageWiseData} />
                        </div>

                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <IncomeJpmcTable isLoading={isLoading} data={businessIncData} />
                        </div>
                    </div> */}

                    {/* <div className="row mt-2 mb-4">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <SectorWiseJpmcTable isLoading={isLoading} data={sectorWiseData} />
                        </div>

                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <FamilyIncomeJpmcTable isLoading={isLoading} data={familyIncData} />
                        </div>
                    </div> */}

                    {/* <div className="row mt-2 mb-4">
                        <div className="col-md-12">
                            <JpmcExpenseTable isLoading={isLoading} data={jpmcExpsData} />
                        </div>
                    </div> */}
                </>
            }

            {/* {
                !loadMore &&
                <div className='d-flex justify-content-center mt-2 mb-3'>
                    <button className="my-services-model-cancel-btn" onClick={() => setLoadMore(true)} >Load More</button>
                </div>
            } */}

        </div>
    )
}

export default JpmcDashboardContainer

